import React, { useEffect, useState, useMemo, useRef } from "react";
import { createPortal } from "react-dom";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaRegFolderOpen } from "react-icons/fa";
import DataParser from "../../utlits/Dataparser";
import Header from "./Header";
import SocketService from "../../Services/SocketService";
import secureLocalStorage from "react-secure-storage";
import { useChatContext } from "../Screens/Chat/ChatContext";
import ChatService from "../../Services/ChatService";
import { message } from "antd";
import { PictureBadge } from "../Reuseable/SecureAvatar";
import ProjectServices from "../../Services/ProjectServices";
import TaskServices from "../../Services/TaskServices";
import CreateTask from "../Screens/Tasks/CreateTask";
import CreateProject from "../Screens/Projects/CreateProject";
import CreateCrmLead from "../Screens/CrmLeads/CreateCrmLead";
// import hrmLogo from '../../../assests/images/HRM.svg';

const getImgUrl = (img) => {
  if (!img || img === "null" || img === "undefined") return null;
  if (img.startsWith("http")) return img;
  const baseUrl = (process.env.REACT_APP_BASE_URL || "http://localhost:5026/api/v1").split("/api/v1")[0];
  if (img.includes("/")) {
    const norm = img.startsWith("/") ? img : `/${img}`;
    return `${baseUrl}${norm.startsWith("/public") ? norm : `/public${norm}`}`;
  }
  return (process.env.REACT_APP_USER_DOCS_PATH || `${baseUrl}/public/users/docs/`) + img;
};

// Module-level cache — survives component remounts and menu toggles within the same session
let _sidebarProjectsCache = [];

const Sidebar = () => {
  // ✅ Initialize from localStorage; default to expanded on tasks/projects pages
  const [sideBarState, setSideBarState] = useState(() => {
    const saved = localStorage.getItem("sideBarState");
    if (saved !== null) return JSON.parse(saved);
    const pathSegs = window.location.pathname.split('/').filter(Boolean);
    const inTasksOrProjects = pathSegs.includes('tasks') || pathSegs.includes('projects');
    const inLeads = ['leads', 'crm-leads', 'crm-pipeline', 'crm-action-queue', 'lead-dashboard'].some(s => pathSegs.includes(s));
    return !(inTasksOrProjects || inLeads); // false = expanded, true = collapsed
  });
  // Only restore submenu state if the sidebar was also stored as expanded; avoids stale open-menu state after manual collapse
  const _sidebarWasExpanded = localStorage.getItem("sideBarState") === "false";
  const [openMenu2, setOpenMenu2] = useState(() => _sidebarWasExpanded && localStorage.getItem("openMenu2") === "true");
  const [openMenuLeaves, setOpenMenuLeaves] = useState(() => _sidebarWasExpanded && localStorage.getItem("openMenuLeaves") === "true"); // Used for the merged Leaves & WFH
  const [openMenu4, setOpenMenu4] = useState(() => _sidebarWasExpanded && localStorage.getItem("openMenu4") === "true"); // Performance Evaluation
  const [openSubLeaves, setOpenSubLeaves] = useState(true); // Inner accordion for Leaves
  const [openSubWfh, setOpenSubWfh] = useState(true); // Inner accordion for WFH
  const [openSubProjectChannels, setOpenSubProjectChannels] = useState(true); // Inner accordion for Project Channels
  const [channelSearchOpen, setChannelSearchOpen] = useState(false);
  const [channelSearch, setChannelSearch] = useState('');
  const [projectChannelSearchOpen, setProjectChannelSearchOpen] = useState(false);
  const [projectChannelSearch, setProjectChannelSearch] = useState('');
  const [inboxSearchOpen, setInboxSearchOpen] = useState(false);
  const [inboxSearch, setInboxSearch] = useState('');
  const channelSearchRef = useRef(null);
  const projectChannelSearchRef = useRef(null);
  const inboxSearchRef = useRef(null);

  useEffect(() => {
    if (!channelSearchOpen && !projectChannelSearchOpen && !inboxSearchOpen) return;
    const handleClickOutside = (e) => {
      if (channelSearchOpen && channelSearchRef.current && !channelSearchRef.current.contains(e.target)) {
        setChannelSearchOpen(false); setChannelSearch('');
      }
      if (projectChannelSearchOpen && projectChannelSearchRef.current && !projectChannelSearchRef.current.contains(e.target)) {
        setProjectChannelSearchOpen(false); setProjectChannelSearch('');
      }
      if (inboxSearchOpen && inboxSearchRef.current && !inboxSearchRef.current.contains(e.target)) {
        setInboxSearchOpen(false); setInboxSearch('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [channelSearchOpen, projectChannelSearchOpen, inboxSearchOpen]);
  const [openSubTasks, setOpenSubTasks] = useState(true); // Inner accordion for Task filters
  const [openSubProjects, setOpenSubProjects] = useState(true); // Inner accordion for Projects list
  const [projectSearchOpen, setProjectSearchOpen] = useState(false);
  const [projectSearch, setProjectSearch] = useState('');
  const [collapsedProjects, setCollapsedProjects] = useState({}); // per-project accordion state
  const [hoverExpanded, setHoverExpanded] = useState(false);
  const [inlineInboxOpen, setInlineInboxOpen] = useState(false);
  const [showSidebarCreateLead, setShowSidebarCreateLead] = useState(false);
  const [sidebarTaskPriority, setSidebarTaskPriority] = useState([]);
  const [sidebarTaskOwner, setSidebarTaskOwner] = useState([]);

  const { rooms, setRooms, openChat, openNewDm, openNewChannel, refreshRooms, activeRoom, isModalOpen, setAnchorRect, unhideConversation, isInboxOpen, setIsInboxOpen, isChannelsOpen, setIsChannelsOpen, closeChat, hideConversation } = useChatContext();

  const unreadRoomsCount = rooms.filter(r => r.unreadCount > 0).length;

  const sortByUnread = (list) =>
    [...list].sort((a, b) => {
      const aUnread = (a.unreadCount || 0) > 0 ? 1 : 0;
      const bUnread = (b.unreadCount || 0) > 0 ? 1 : 0;
      if (bUnread !== aUnread) return bUnread - aUnread;
      const aTime = new Date(a.last_message?.createdAt || a.createdAt || 0).getTime();
      const bTime = new Date(b.last_message?.createdAt || b.createdAt || 0).getTime();
      return bTime - aTime;
    });

  const [dmSearch, setDmSearch] = useState("");
  const [dmResults, setDmResults] = useState([]);


  const handleDmSearch = async (val) => {
    setDmSearch(val);
    if (!val.trim()) { setDmResults([]); return; }
    try {
      const res = await ChatService.searchUsers(val);
      if (res.Good) setDmResults(res.users);
    } catch (e) { }
  };

  const handleStartDm = async (userId) => {
    try {
      const res = await ChatService.getOrCreateRoom({ type: "direct", targetId: userId });
      if (res.Good) {
        unhideConversation(res.room._id);
        SocketService.emit("joinChatRoom", res.room._id);
        setRooms(prev => prev.find(r => r._id === res.room._id) ? prev : [res.room, ...prev]);
        setDmSearch(""); setDmResults([]);
        setInlineInboxOpen(false);
        setIsInboxOpen(true);
        openChat(res.room);
      }
    } catch (e) { }
  };

  const navigate = useNavigate();
  const location = useLocation(); // ✅ for active tab tracking

  const isMobile = () => window.innerWidth <= 992;

  const handleChange = () => {
    if (isMobile()) {
      // On mobile: toggle sidebar-enable class (shows/hides the sidebar)
      document.body.classList.toggle("sidebar-enable");
    } else {
      // On desktop: toggle the icon-only collapsed state
      const newState = !sideBarState;
      setSideBarState(newState);
      localStorage.setItem("sideBarState", JSON.stringify(newState));
    }
  };

  // ✅ Use useLayoutEffect for immediate class application before paint
  React.useLayoutEffect(() => {
    if (sideBarState) {
      document.body.classList.add("vertical-collpsed");
    } else {
      document.body.classList.remove("vertical-collpsed");
    }
  }, [sideBarState]);

  // ✅ Robust mount sync to override any late-running scripts
  useEffect(() => {
    const syncSidebar = () => {
      if (sideBarState) {
        document.body.classList.add("vertical-collpsed");
      } else {
        document.body.classList.remove("vertical-collpsed");
      }
    };
    syncSidebar();
    const timer = setTimeout(syncSidebar, 100); // Small delay for late scripts
    return () => clearTimeout(timer);
  }, [sideBarState]);

  useEffect(() => {
    const companyId = DataParser.CompanyId();
    if (companyId) {
      TaskServices.getDueTodayTask(companyId).then((res) => {
        if (res?.data?.priority) setSidebarTaskPriority(res.data.priority);
        if (res?.data?.task_owner) setSidebarTaskOwner(res.data.task_owner);
      }).catch(() => {});
    }
  }, []);

  const [userPermissions, setuserPermissions] = useState([]);
  const [usertype, setusertype] = useState("");
  useEffect(() => {
    const usertyp = DataParser.UserType();
    setusertype(usertyp);
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);

    // 🟢 Socket Integration for Global Permission Updates
    SocketService.connect();
    const roleId = DataParser.RoleId();
    if (roleId) {
      SocketService.emit("registerRole", roleId);
    }

    const handlePermissionsUpdate = (data) => {
      // Check if the update is for this user's role (double check, though room should ensure it)
      if (data.roleId == roleId) {

        // 1. Update Local Storage
        const adminInfo = JSON.parse(secureLocalStorage.getItem("adminInfo")) || {};
        if (adminInfo?.user?.userdata) {
          adminInfo.user.userdata.user_permissions = data.permissions;
          secureLocalStorage.setItem("adminInfo", JSON.stringify(adminInfo));
        }

        // 2. Update State
        setuserPermissions(data.permissions);

        // 3. Dispatch Event (for other components if needed)
        window.dispatchEvent(new Event("permissionsUpdated"));
      }
    };

    // Listen to socket event
    SocketService.on("updatePermissions", handlePermissionsUpdate);

    // Also listen to local event (from EditRole.jsx or self)
    const handleLocalUpdate = () => {
      const updatedPermissions = DataParser.CompanyUserPermissions();
      setuserPermissions(updatedPermissions);
    };
    window.addEventListener("permissionsUpdated", handleLocalUpdate);

    return () => {
      SocketService.off("updatePermissions", handlePermissionsUpdate);
      window.removeEventListener("permissionsUpdated", handleLocalUpdate);
    };
  }, []);

  // Tooltips disabled - Redundant with new flyout design
  useEffect(() => {
    if (window.bootstrap && window.bootstrap.Tooltip) {
      document.querySelectorAll('.tooltip').forEach(el => el.remove());
    }
  }, [sideBarState]);


  // Set --flyout-top on all side-menu li elements so hover cards never fall back to 0px.
  // We set it on BOTH the li and the sub-menu element so the CSS var resolves from the
  // element's own inline property, not from a stale inherited value.
  useEffect(() => {
    const presetAll = () => {
      const sideMenu = document.getElementById('side-menu');
      if (!sideMenu) return;
      sideMenu.querySelectorAll(':scope > li').forEach(li => {
        const rect = li.getBoundingClientRect();
        li.style.setProperty('--flyout-top', rect.top + 'px');
        li.style.setProperty('--li-top', rect.top + 'px');
        const sub = li.querySelector(':scope > ul.sub-menu');
        if (sub) sub.style.setProperty('--flyout-top', rect.top + 'px');
      });
    };

    presetAll();
    const frameId = requestAnimationFrame(presetAll);

    // ── Hover-delay: keep flyout open during diagonal mouse movement ──────────
    // When the mouse leaves a sidebar li, give it 130ms to reach the submenu
    // before closing. If it enters the submenu (or another li) in time, cancel.
    let flyTimer = null;
    let flyLi = null;

    // Use mouseover on document.body — more reliable than mouseenter on #side-menu
    // because document.body is never replaced by React re-renders.
    //
    // IMPORTANT: this fires on every bubbling mouseover, including from each nested
    // row inside the flyout as the cursor moves across them (e.g. scrolling through
    // Chat's channel list). Bail out immediately if this li is already the open one —
    // otherwise every such event would reset --flyout-top back to the icon's raw
    // position and only correct it a frame later, making a tall/repositioned flyout
    // (one that had to shift up to fit the viewport) visibly jump on every mouse
    // movement inside it, occasionally jumping out from under the cursor entirely
    // and closing itself.
    const onMouseOver = (e) => {
      const li = e.target?.closest?.('#side-menu > li');
      if (!li) return;
      if (li === flyLi) return;
      const sub = li.querySelector(':scope > ul.sub-menu');
      if (!sub) return;
      const rect = li.getBoundingClientRect();
      // --li-top always tracks the actual menu-item position (used by the beak)
      li.style.setProperty('--li-top', rect.top + 'px');
      li.style.setProperty('--flyout-top', rect.top + 'px');
      sub.style.setProperty('--flyout-top', rect.top + 'px');
      if (li.classList.contains('mm-active') && sub.classList.contains('mm-show')) return;
      requestAnimationFrame(() => {
        const appVhStr = getComputedStyle(document.documentElement).getPropertyValue('--app-vh');
        const appVh = appVhStr ? parseFloat(appVhStr) : window.innerHeight;
        const subRect = sub.getBoundingClientRect();
        if (subRect.bottom > appVh) {
          const adjusted = Math.max(0, appVh - subRect.height - 8);
          // Only shift the flyout — the beak (--li-top) stays on the menu item
          li.style.setProperty('--flyout-top', adjusted + 'px');
          sub.style.setProperty('--flyout-top', adjusted + 'px');
        }
      });
    };

    document.body.addEventListener('mouseover', onMouseOver);
    window.addEventListener('resize', presetAll);

    const cancelFly = () => { clearTimeout(flyTimer); flyTimer = null; };

    const openFly = (li) => {
      cancelFly();
      if (flyLi && flyLi !== li) flyLi.classList.remove('sidebar-fly-active');
      flyLi = li;
      li.classList.add('sidebar-fly-active');
    };

    const scheduleFlyClose = () => {
      cancelFly();
      // A room's context menu (Mute/Mark as Unread/Delete) is open in a portal outside
      // this <li> — don't close the flyout out from under it. The dropdown's own
      // close (roomMenuOpenId -> null) re-checks hover state and closes it if needed.
      if (roomMenuOpenIdRef.current) return;
      flyTimer = setTimeout(() => {
        if (flyLi) { flyLi.classList.remove('sidebar-fly-active'); flyLi = null; }
      }, 200);
    };

    const onMouseOut = (e) => {
      const li = e.target?.closest?.('#side-menu > li');
      if (!li) return;
      // null relatedTarget = cursor moved to a native OS element (e.g. Mac overlay scrollbar,
      // window chrome, tooltip). Don't close — mouseover fires again when cursor returns to DOM,
      // and the document mouseleave handler covers the window-exit case.
      if (!e.relatedTarget) return;
      // Cursor is still inside this li's subtree (e.g. moving within submenu) — keep open.
      if (li.contains(e.relatedTarget)) return;
      scheduleFlyClose();
    };

    // Close when cursor genuinely leaves the browser window (handles null-relatedTarget gap)
    const onDocMouseLeave = () => scheduleFlyClose();
    document.addEventListener('mouseleave', onDocMouseLeave);

    // Piggyback on the existing mouseover to set the active class immediately
    const originalOnMouseOver = onMouseOver;
    const onMouseOverWithFly = (e) => {
      originalOnMouseOver(e);
      const li = e.target?.closest?.('#side-menu > li');
      if (li) openFly(li);
    };

    document.body.removeEventListener('mouseover', onMouseOver);
    document.body.addEventListener('mouseover', onMouseOverWithFly);
    document.body.addEventListener('mouseout', onMouseOut);

    return () => {
      cancelAnimationFrame(frameId);
      cancelFly();
      if (flyLi) flyLi.classList.remove('sidebar-fly-active');
      document.body.removeEventListener('mouseover', onMouseOverWithFly);
      document.body.removeEventListener('mouseout', onMouseOut);
      document.removeEventListener('mouseleave', onDocMouseLeave);
      window.removeEventListener('resize', presetAll);
    };
  }, [sideBarState]);

  const handleToogleMenu2 = () => {
    if (!openMenu2) {
      const cr = DataParser.CompanyIdentifierRole() || '';
      if (userPermissions.includes("dashboard-list"))           navigate(`/${cr}/dashboard`);
      else if (userPermissions.includes("hrattendance-list"))   navigate(`/${cr}/attendance`);
      else if (userPermissions.includes("hrleaverequest-list")) navigate(`/${cr}/leaves`);
      else if (userPermissions.includes("hrwfhrequest-list"))   navigate(`/${cr}/wfh_hr`);
      else if (userPermissions.includes("policy-list"))         navigate(`/${cr}/policy`);
      if (sideBarState) return;
    }
    const nextState = !openMenu2;
    setOpenMenu2(nextState);
    setOpenMenuLeaves(false);
    setOpenMenu4(false);
    setOpenMenuChat(false);
    setOpenMenuTasksProjects(false);
    setOpenMenuLeadsCrm(false);

    // Persist all menu states
    localStorage.setItem("openMenu2", nextState);
    localStorage.setItem("openMenuLeaves", "false");
    localStorage.setItem("openMenu4", "false");
    localStorage.setItem("openMenuChat", "false");
    localStorage.setItem("openMenuTasksProjects", "false");
    localStorage.setItem("openMenuLeadsCrm", "false");

    // If closing, set state to true (Collapsed/70px), if opening set to false (Pinned/310px)
    setSideBarState(!nextState);
    localStorage.setItem("sideBarState", JSON.stringify(!nextState));
  };

  const [openMenuChat, setOpenMenuChat] = useState(() => _sidebarWasExpanded && localStorage.getItem("openMenuChat") === "true");
  const [openMenuTasksProjects, setOpenMenuTasksProjects] = useState(() => {
    if (_sidebarWasExpanded && localStorage.getItem("openMenuTasksProjects") === "true") return true;
    // Auto-open on tasks/projects pages even before companyRole is available
    const pathSegs = window.location.pathname.split('/').filter(Boolean);
    return pathSegs.includes('tasks') || pathSegs.includes('projects');
  });
  const [sidebarProjects, setSidebarProjects] = useState(_sidebarProjectsCache);

  useEffect(() => {
    if (!openMenuTasksProjects || !openSubProjects) {
      setProjectSearchOpen(false);
      setProjectSearch('');
    }
  }, [openMenuTasksProjects, openSubProjects]);

  const [openMenuLeadsCrm, setOpenMenuLeadsCrm] = useState(() => {
    if (_sidebarWasExpanded && localStorage.getItem("openMenuLeadsCrm") === "true") return true;
    // Auto-open on any leads/pipeline/queue/dashboard page (same pattern as Tasks)
    const pathSegs = window.location.pathname.split('/').filter(Boolean);
    return ['leads', 'crm-leads', 'crm-pipeline', 'crm-action-queue', 'lead-dashboard'].some(s => pathSegs.includes(s));
  });

  // Auto-pin Chat flyout when the chat modal first opens
  useEffect(() => {
    if (!isModalOpen) return;
    setOpenMenuChat(true);
    setOpenMenu2(false);
    setOpenMenuLeaves(false);
    setOpenMenu4(false);
    setOpenMenuTasksProjects(false);
    setOpenMenuLeadsCrm(false);
    setSideBarState(false);
    localStorage.setItem("openMenuChat", "true");
    localStorage.setItem("openMenu2", "false");
    localStorage.setItem("openMenuLeaves", "false");
    localStorage.setItem("openMenu4", "false");
    localStorage.setItem("openMenuTasksProjects", "false");
    localStorage.setItem("openMenuLeadsCrm", "false");
    localStorage.setItem("sideBarState", JSON.stringify(false));
  }, [isModalOpen]);

  // When the active room changes (notification click, invite, redirect):
  // — reopen the chat menu if it was somehow closed while modal was open
  // — scroll the newly-active room into view in the sidebar list
  useEffect(() => {
    if (!activeRoom) return;
    if (isModalOpen && !openMenuChat) {
      setOpenMenuChat(true);
      setSideBarState(false);
      localStorage.setItem("openMenuChat", "true");
      localStorage.setItem("sideBarState", JSON.stringify(false));
    }
    const timer = setTimeout(() => {
      const el = document.querySelector('.chat-item-link.active');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 350);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeRoom]);

  // Reset inline inputs when chat menu closes or sidebar collapses
  useEffect(() => {
    if (!openMenuChat || sideBarState) {
      setInlineInboxOpen(false);
      setDmSearch(""); setDmResults([]);
    }
  }, [openMenuChat, sideBarState]);

  const handleToggleChat = (e = null) => {
    const nextState = !openMenuChat;
    setOpenMenuChat(nextState);
    setOpenMenu2(false);
    setOpenMenuLeaves(false);
    setOpenMenu4(false);
    setOpenMenuTasksProjects(false);
    setOpenMenuLeadsCrm(false);
    localStorage.setItem("openMenuChat", nextState);
    localStorage.setItem("openMenu2", "false");
    localStorage.setItem("openMenuLeaves", "false");
    localStorage.setItem("openMenu4", "false");
    localStorage.setItem("openMenuTasksProjects", "false");
    localStorage.setItem("openMenuLeadsCrm", "false");
    setSideBarState(!nextState);
    localStorage.setItem("sideBarState", JSON.stringify(!nextState));

    // If modal is open and we are closing the flyout, point to the main icon
    if (isModalOpen && !nextState && e) {
      const rect = e.currentTarget.getBoundingClientRect();
      if (setAnchorRect) setAnchorRect(rect);
    }
  };

  const handleToggleTasksProjects = () => {
    if (!openMenuTasksProjects) {
      const cr = DataParser.CompanyIdentifierRole() || '';
      if (userPermissions.includes("tasks-list"))        navigate(`/${cr}/tasks`);
      else if (userPermissions.includes("project-list")) navigate(`/${cr}/projects`);
      if (sideBarState) return;
    }
    const nextState = !openMenuTasksProjects;
    setOpenMenuTasksProjects(nextState);
    setOpenMenuChat(false);
    setOpenMenu2(false);
    setOpenMenuLeaves(false);
    setOpenMenu4(false);
    setOpenMenuLeadsCrm(false);
    localStorage.setItem("openMenuTasksProjects", nextState);
    localStorage.setItem("openMenuChat", "false");
    localStorage.setItem("openMenu2", "false");
    localStorage.setItem("openMenuLeaves", "false");
    localStorage.setItem("openMenu4", "false");
    localStorage.setItem("openMenuLeadsCrm", "false");
    setSideBarState(!nextState);
    localStorage.setItem("sideBarState", JSON.stringify(!nextState));
  };

  const handleToggleLeadsCrm = () => {
    if (!openMenuLeadsCrm) {
      navigate(`/${DataParser.CompanyIdentifierRole() || ''}/leads`);
      if (sideBarState) return;
    }
    const nextState = !openMenuLeadsCrm;
    setOpenMenuLeadsCrm(nextState);
    setOpenMenuChat(false);
    setOpenMenu2(false);
    setOpenMenuLeaves(false);
    setOpenMenu4(false);
    setOpenMenuTasksProjects(false);
    localStorage.setItem("openMenuLeadsCrm", nextState);
    localStorage.setItem("openMenuChat", "false");
    localStorage.setItem("openMenu2", "false");
    localStorage.setItem("openMenuLeaves", "false");
    localStorage.setItem("openMenu4", "false");
    localStorage.setItem("openMenuTasksProjects", "false");
    setSideBarState(!nextState);
    localStorage.setItem("sideBarState", JSON.stringify(!nextState));
  };

  const currentUserId = DataParser.GetLoggedInUser()?.user?.userdata?.id;

  const [roomMenuOpenId, setRoomMenuOpenId] = useState(null);
  const [roomMenuReady, setRoomMenuReady] = useState(false);
  const [roomMenuPos, setRoomMenuPos] = useState({ top: 0, left: 0 });
  const [roomToDelete, setRoomToDelete] = useState(null);

  // Mirrors roomMenuOpenId for the hover-flyout effect below (it binds its listeners
  // once and reads this ref on every mouseout, rather than re-binding on every open/close).
  const roomMenuOpenIdRef = useRef(null);
  useEffect(() => { roomMenuOpenIdRef.current = roomMenuOpenId; }, [roomMenuOpenId]);

  // The room-menu dropdown lives in a portal outside the sidebar's <li> (see below), so
  // moving the mouse onto it looks like "left the flyout" to the hover-close logic. Once
  // the dropdown closes, if the cursor isn't actually back over the flyout's <li>, close
  // the flyout too instead of leaving it stuck open.
  useEffect(() => {
    if (roomMenuOpenId) return;
    const activeLi = document.querySelector('#side-menu > li.sidebar-fly-active');
    if (activeLi && !activeLi.matches(':hover')) {
      activeLi.classList.remove('sidebar-fly-active');
    }
  }, [roomMenuOpenId]);

  // Room "more options" menu is rendered through a portal (see bottom of render)
  // so it escapes the chat flyout's `overflow-y: auto` clipping and z-index stack —
  // it used to be positioned absolutely inside the scrollable list, which cut it off
  // whenever the row was near the bottom of the (short) collapsed-sidebar hover card.
  const openRoomMenu = (e, roomId) => {
    e.preventDefault();
    e.stopPropagation();
    if (roomMenuOpenId === roomId) { setRoomMenuOpenId(null); return; }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuWidth = 160;
    const menuHeight = 100;
    const top = window.innerHeight - rect.bottom > menuHeight + 10 ? rect.bottom + 4 : rect.top - menuHeight - 4;
    const left = Math.min(rect.right - menuWidth, window.innerWidth - menuWidth - 8);
    setRoomMenuPos({ top: Math.max(4, top), left: Math.max(8, left) });
    setRoomMenuOpenId(roomId);
  };

  // DM delete: requires "chat-delete" backend role permission.
  // Channel/project delete: creator OR "Full edit" chat-room permission.
  const canDeleteRoom = (room) => {
    if (room.type === "direct") {
      return userPermissions.includes("chat-delete");
    }
    if (String(room.created_by) === String(currentUserId)) return true;
    const myPerm = (room.memberPermissions || []).find(p => String(p.userId) === String(currentUserId));
    return myPerm?.permission === "Full edit";
  };

  const handleDeleteRoom = (room) => {
    setRoomMenuOpenId(null);
    setRoomToDelete(room);
    document.getElementById("openDeleteChatRoomModal").click();
  };

  const confirmDeleteRoom = async () => {
    if (!roomToDelete) return;
    document.getElementById("closeDeleteChatRoomModal").click();
    try {
      if (roomToDelete.type === "direct") {
        // hideConversation handles: localStorage hidden list, cleared_at timestamp,
        // setRooms filter, and closing the panel if active.
        hideConversation(roomToDelete._id || roomToDelete.id);
      } else {
        await ChatService.leaveRoom({ roomId: roomToDelete._id, userId: currentUserId });
        setRooms(prev => prev.filter(r => r._id !== roomToDelete._id));
        const deletedId = String(roomToDelete._id || roomToDelete.id || "");
        const activeId = String(activeRoom?._id || activeRoom?.id || "");
        if (deletedId && activeId && deletedId === activeId) {
          closeChat();
        }
      }
    } catch { message.error("Failed to remove chat"); }
    setRoomToDelete(null);
  };

  const handleMuteRoom = async (room) => {
    setRoomMenuOpenId(null);
    try {
      const res = await ChatService.muteRoom(room._id);
      if (res?.Good) {
        setRooms(prev => prev.map(r => r._id === room._id ? { ...r, is_muted: res.data.is_muted } : r));
        message.success(res.data.is_muted ? "Chat muted" : "Chat unmuted");
      }
    } catch { message.error("Failed to mute chat"); }
  };

  const handleMarkAsUnread = async (room) => {
    setRoomMenuOpenId(null);
    try {
      const res = await ChatService.markAsUnread(room._id);
      if (res?.Good) {
        setRooms(prev => prev.map(r => r._id === room._id ? { ...r, unreadCount: Math.max(r.unreadCount || 0, 1), force_unread: true } : r));
      }
    } catch { message.error("Failed to mark as unread"); }
  };
  useEffect(() => {
    if (!roomMenuOpenId) { setRoomMenuReady(false); return; }
    const t = setTimeout(() => setRoomMenuReady(true), 180);
    const close = (e) => {
      if (!e.target.closest('.room-menu-dropdown') && !e.target.closest('.room-menu-btn')) {
        setRoomMenuOpenId(null);
      }
    };
    // Capture phase bypasses any stopPropagation() calls in child elements
    document.addEventListener("mousedown", close, true);
    return () => { clearTimeout(t); document.removeEventListener("mousedown", close, true); };
  }, [roomMenuOpenId]);

  const isDeletedMember = (m) => !m || m.is_deleted === true || m.status === 0 || m.status === "0";

  const getChatRoomName = (room) => {
    if (room.type === "direct" && room.members?.length > 0) {
      const other = room.members.find(m => String(m.id || m._id) !== String(currentUserId));
      if (isDeletedMember(other)) return "Deleted User";
      return `${other.first_name || ""} ${other.last_name || ""}`.trim() || "Deleted User";
    }
    return room.name || "Unnamed";
  };

  const handleToogleMenuLeaves = () => {
    if (!openMenuLeaves) {
      const cr = DataParser.CompanyIdentifierRole() || '';
      if (userPermissions.includes("myleave-list"))                  navigate(`/${cr}/employee_leaves`);
      else if (userPermissions.includes("myteamleavesrequest-list")) navigate(`/${cr}/leaves_team`);
      else if (userPermissions.includes("mywfh-list"))               navigate(`/${cr}/employee_wfh`);
      else if (userPermissions.includes("myteamwfhrequest-list"))    navigate(`/${cr}/wfh_approvals`);
      if (sideBarState) return;
    }
    const nextState = !openMenuLeaves;
    setOpenMenuLeaves(nextState);
    setOpenMenu2(false);
    setOpenMenu4(false);
    setOpenMenuChat(false);
    setOpenMenuTasksProjects(false);
    setOpenMenuLeadsCrm(false);

    // Persist all menu states
    localStorage.setItem("openMenuLeaves", nextState);
    localStorage.setItem("openMenu2", "false");
    localStorage.setItem("openMenu4", "false");
    localStorage.setItem("openMenuChat", "false");
    localStorage.setItem("openMenuTasksProjects", "false");
    localStorage.setItem("openMenuLeadsCrm", "false");

    // If closing, set state to true (Collapsed/70px), if opening set to false (Pinned/310px)
    setSideBarState(!nextState);
    localStorage.setItem("sideBarState", JSON.stringify(!nextState));
  };

  const handleToogleMenu4 = () => {
    if (!openMenu4) {
      const cr = DataParser.CompanyIdentifierRole() || '';
      if (userPermissions.includes("Userevaluation-list"))       navigate(`/${cr}/evaluation`);
      else if (userPermissions.includes("myevaluation-list"))    navigate(`/${cr}/myevaluation`);
      if (sideBarState) return;
    }
    const nextState = !openMenu4;
    setOpenMenu4(nextState);
    setOpenMenu2(false);
    setOpenMenuLeaves(false);
    setOpenMenuChat(false);
    setOpenMenuTasksProjects(false);
    setOpenMenuLeadsCrm(false);

    // Persist all menu states
    localStorage.setItem("openMenu4", nextState);
    localStorage.setItem("openMenu2", "false");
    localStorage.setItem("openMenuLeaves", "false");
    localStorage.setItem("openMenuChat", "false");
    localStorage.setItem("openMenuTasksProjects", "false");
    localStorage.setItem("openMenuLeadsCrm", "false");

    // If closing, set state to true (Collapsed/70px), if opening set to false (Pinned/310px)
    setSideBarState(!nextState);
    localStorage.setItem("sideBarState", JSON.stringify(!nextState));
  };

  // ✅ helper function for active tab highlighting - strict check
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");

  // ✅ helper function for parent active highlighting - strict check
  const isParentActive = (paths) => paths.some(path => location.pathname === path || location.pathname.startsWith(path + "/"));

  // ✅ Stable path arrays using useMemo
  const companyRole = DataParser.CompanyIdentifierRole() || "";
  const canCreateTask = DataParser.userRoleTitle() === 'Company Admin' || DataParser.isHead?.() === 'yes';

  // ── Meetings / Notes flyouts (as Tasks): pinned on their own pages; any other flyout opened takes over,
  //    and their own icon closes them. Derived from the page, so the other menus' handlers need no change.
  const meetingsPath = `/${companyRole}/meetings`;
  const notesPath = `/${companyRole}/notes`;
  const [mnDismissed, setMnDismissed] = useState(false);
  useEffect(() => { setMnDismissed(false); }, [location.pathname]);
  const otherFlyoutOpen = openMenu2 || openMenuLeaves || openMenu4 || openMenuChat || openMenuTasksProjects || openMenuLeadsCrm;
  const mnPinned = !otherFlyoutOpen && !mnDismissed && !sideBarState;
  const openMenuMeetings = mnPinned && isActive(meetingsPath);
  const openMenuNotes = mnPinned && isActive(notesPath);
  const [openSubMeetings, setOpenSubMeetings] = useState(true);
  const [openSubNotes, setOpenSubNotes] = useState(true);
  const handleToggleMeetingsNotes = (path, pinned) => {
    if (pinned) {
      // close it: back to icon mode, as the other flyouts' icons do
      setMnDismissed(true);
      setSideBarState(true);
      localStorage.setItem("sideBarState", JSON.stringify(true));
      return;
    }
    setMnDismissed(false);
    [setOpenMenu2, setOpenMenuLeaves, setOpenMenu4, setOpenMenuChat, setOpenMenuTasksProjects, setOpenMenuLeadsCrm].forEach((set) => set(false));
    ["openMenu2", "openMenuLeaves", "openMenu4", "openMenuChat", "openMenuTasksProjects", "openMenuLeadsCrm"].forEach((k) => localStorage.setItem(k, "false"));
    setSideBarState(false);
    localStorage.setItem("sideBarState", JSON.stringify(false));
    if (!isActive(path)) navigate(path);
  };
  const MEETING_TABS = [
    { key: "all", label: "All", icon: "uil-list-ul" },
    { key: "in_progress", label: "In progress", icon: "uil-clock" },
    { key: "upcoming", label: "Upcoming", icon: "uil-calendar-alt" },
    { key: "due_7_days", label: "Due in 7 days", icon: "uil-schedule" },
    { key: "overdue", label: "Overdue", icon: "uil-exclamation-circle" },
    { key: "completed", label: "Completed", icon: "uil-check-circle" },
    { key: "deleted", label: "Recently deleted", icon: "uil-trash-alt", perm: "meetings-delete" },
  ];
  const NOTE_TABS = [
    { key: "active", label: "Notes", icon: "uil-file-alt" },
    { key: "completed", label: "Completed", icon: "uil-check-circle" },
    { key: "archived", label: "Archived", icon: "uil-archive" },
    { key: "shared", label: "Shared with me", icon: "uil-users-alt" },
    { key: "deleted", label: "Recently deleted", icon: "uil-trash-alt", perm: "notes-delete" },
  ];

  const hrPaths = useMemo(() => [
    `/${companyRole}/dashboard`,
    `/${companyRole}/attendance`,
    `/${companyRole}/leaves`,
    `/${companyRole}/wfh_hr`,
    `/${companyRole}/policy`,
  ], [companyRole]);

  const leavesPaths = useMemo(() => [
    `/${companyRole}/employee_leaves`,
    `/${companyRole}/leaves_team`,
  ], [companyRole]);

  const wfhPaths = useMemo(() => [
    `/${companyRole}/employee_wfh`,
    `/${companyRole}/wfh_approvals`,
  ], [companyRole]);

  const performancePaths = useMemo(() => [
    `/${companyRole}/evaluation`,
    `/${companyRole}/teamevaluations`,
    `/${companyRole}/all-users-evaluations`,
    `/${companyRole}/myevaluation`,
  ], [companyRole]);

  const leadsPaths = useMemo(() => [
    `/${companyRole}/leads`,
    `/${companyRole}/crm-leads`,
    `/${companyRole}/crm-pipeline`,
    `/${companyRole}/crm-action-queue`,
    `/${companyRole}/lead-dashboard`,
  ], [companyRole]);

  // Close mobile sidebar on route change
  useEffect(() => {
    if (isMobile()) {
      document.body.classList.remove("sidebar-enable");
    }
  }, [location.pathname]);

  // ✅ Mutually exclusive flyout manager — on every route change, determine which flyout
  //    (if any) belongs to the current page and pin ONLY that one. Close all others.
  //    If the page has no flyout (e.g. Attendance, Settings), collapse the sidebar to icon mode.
  useEffect(() => {
    if (!companyRole) return; // wait until companyRole is available
    const isMatch = (p) => location.pathname === p || location.pathname.startsWith(p + "/");
    const tasksPath = `/${companyRole}/tasks`;
    const projectsPath = `/${companyRole}/projects`;

    // Determine which flyout owns the current route
    const isHR = hrPaths.some(isMatch);
    const isLeaves = leavesPaths.some(isMatch) || wfhPaths.some(isMatch);
    const isPerf = performancePaths.some(isMatch);
    const isTasks = isMatch(tasksPath) || isMatch(projectsPath);
    // Path-segment fallback ensures lead-dashboard pins even if companyRole isn't resolved yet
    const _pathSegs = location.pathname.split('/').filter(Boolean);
    const isLeads = leadsPaths.some(isMatch) ||
      ['leads', 'crm-leads', 'crm-pipeline', 'crm-action-queue', 'lead-dashboard'].some(s => _pathSegs.includes(s));
    // Chat has no route — it's opened via modal/overlay, so we leave its state untouched.
    // Meetings / Notes: their flyout pins from the page itself (see openMenuMeetings / openMenuNotes)
    const isMeetingsNotes = isMatch(`/${companyRole}/meetings`) || isMatch(`/${companyRole}/notes`);
    const anyFlyout = isHR || isLeaves || isPerf || isTasks || isLeads || isMeetingsNotes;

    if (isHR) {
      // Pin HR, close all others
      setOpenMenu2(true);
      setOpenMenuLeaves(false);
      setOpenMenu4(false);
      setOpenMenuTasksProjects(false);
      setOpenMenuLeadsCrm(false);
      setOpenMenuChat(false);
      setSideBarState(false); // expand sidebar
      localStorage.setItem("openMenu2", "true");
      localStorage.setItem("openMenuLeaves", "false");
      localStorage.setItem("openMenu4", "false");
      localStorage.setItem("openMenuTasksProjects", "false");
      localStorage.setItem("openMenuLeadsCrm", "false");
      localStorage.setItem("openMenuChat", "false");
      localStorage.setItem("sideBarState", "false");
    } else if (isLeaves) {
      // Pin Leaves & WFH, close all others
      setOpenMenuLeaves(true);
      setOpenMenu2(false);
      setOpenMenu4(false);
      setOpenMenuTasksProjects(false);
      setOpenMenuLeadsCrm(false);
      setOpenMenuChat(false);
      setSideBarState(false);
      localStorage.setItem("openMenuLeaves", "true");
      localStorage.setItem("openMenu2", "false");
      localStorage.setItem("openMenu4", "false");
      localStorage.setItem("openMenuTasksProjects", "false");
      localStorage.setItem("openMenuLeadsCrm", "false");
      localStorage.setItem("openMenuChat", "false");
      localStorage.setItem("sideBarState", "false");
    } else if (isPerf) {
      // Pin Performance Evaluation, close all others
      setOpenMenu4(true);
      setOpenMenu2(false);
      setOpenMenuLeaves(false);
      setOpenMenuTasksProjects(false);
      setOpenMenuLeadsCrm(false);
      setOpenMenuChat(false);
      setSideBarState(false);
      localStorage.setItem("openMenu4", "true");
      localStorage.setItem("openMenu2", "false");
      localStorage.setItem("openMenuLeaves", "false");
      localStorage.setItem("openMenuTasksProjects", "false");
      localStorage.setItem("openMenuLeadsCrm", "false");
      localStorage.setItem("openMenuChat", "false");
      localStorage.setItem("sideBarState", "false");
    } else if (isTasks) {
      // Pin Tasks & Projects, close all others
      setOpenMenuTasksProjects(true);
      setOpenMenu2(false);
      setOpenMenuLeaves(false);
      setOpenMenu4(false);
      setOpenMenuLeadsCrm(false);
      setOpenMenuChat(false);
      setSideBarState(false);
      localStorage.setItem("openMenuTasksProjects", "true");
      localStorage.setItem("openMenu2", "false");
      localStorage.setItem("openMenuLeaves", "false");
      localStorage.setItem("openMenu4", "false");
      localStorage.setItem("openMenuLeadsCrm", "false");
      localStorage.setItem("openMenuChat", "false");
      localStorage.setItem("sideBarState", "false");
    } else if (isLeads) {
      // Pin Leads, close all others
      setOpenMenuLeadsCrm(true);
      setOpenMenu2(false);
      setOpenMenuLeaves(false);
      setOpenMenu4(false);
      setOpenMenuTasksProjects(false);
      setOpenMenuChat(false);
      setSideBarState(false);
      localStorage.setItem("openMenuLeadsCrm", "true");
      localStorage.setItem("openMenu2", "false");
      localStorage.setItem("openMenuLeaves", "false");
      localStorage.setItem("openMenu4", "false");
      localStorage.setItem("openMenuTasksProjects", "false");
      localStorage.setItem("openMenuChat", "false");
      localStorage.setItem("sideBarState", "false");
    } else if (isMeetingsNotes) {
      // Meetings / Notes: close all the other flyouts and expand; their own flyout then shows
      setOpenMenu2(false);
      setOpenMenuLeaves(false);
      setOpenMenu4(false);
      setOpenMenuTasksProjects(false);
      setOpenMenuLeadsCrm(false);
      setOpenMenuChat(false);
      setSideBarState(false);
      localStorage.setItem("openMenu2", "false");
      localStorage.setItem("openMenuLeaves", "false");
      localStorage.setItem("openMenu4", "false");
      localStorage.setItem("openMenuTasksProjects", "false");
      localStorage.setItem("openMenuLeadsCrm", "false");
      localStorage.setItem("openMenuChat", "false");
      localStorage.setItem("sideBarState", "false");
    } else {
      // No flyout for this page — close ALL flyouts and collapse the sidebar to icon mode
      setOpenMenu2(false);
      setOpenMenuLeaves(false);
      setOpenMenu4(false);
      setOpenMenuTasksProjects(false);
      setOpenMenuLeadsCrm(false);
      setOpenMenuChat(false);
      setSideBarState(true); // collapse to icon-only (70px)
      localStorage.setItem("openMenu2", "false");
      localStorage.setItem("openMenuLeaves", "false");
      localStorage.setItem("openMenu4", "false");
      localStorage.setItem("openMenuTasksProjects", "false");
      localStorage.setItem("openMenuLeadsCrm", "false");
      localStorage.setItem("openMenuChat", "false");
      localStorage.setItem("sideBarState", "true");
    }
  }, [location.pathname, hrPaths, leavesPaths, wfhPaths, performancePaths, leadsPaths, companyRole]);

  // Refresh sidebar projects when a project is created in the same tab
  useEffect(() => {
    const handleProjectsUpdated = () => {
      const companyId = DataParser.CompanyId();
      if (!companyId) return;
      ProjectServices.getProjectsList(companyId).then(res => {
        if (res?.Good) {
          _sidebarProjectsCache = res.projects || [];
          setSidebarProjects(_sidebarProjectsCache);
        }
      }).catch(() => {});
    };
    window.addEventListener("planit:projectsUpdated", handleProjectsUpdated);
    return () => window.removeEventListener("planit:projectsUpdated", handleProjectsUpdated);
  }, []);

  // Fetch sidebar projects on mount — no gate, so projects are ready whenever the menu opens
  useEffect(() => {
    const companyId = DataParser.CompanyId();
    if (!companyId) return;
    ProjectServices.getProjectsList(companyId).then(res => {
      if (res?.Good) {
        _sidebarProjectsCache = res.projects || [];
        setSidebarProjects(_sidebarProjectsCache);
      }
    }).catch(() => {});
  }, []);

  // Re-fetch via socket when a project is created/updated and the menu is open
  useEffect(() => {
    if (!openMenuTasksProjects) return;
    const companyId = DataParser.CompanyId();
    if (!companyId) return;

    const fetchSidebarProjects = () => {
      ProjectServices.getProjectsList(companyId).then(res => {
        if (res?.Good) {
          _sidebarProjectsCache = res.projects || [];
          setSidebarProjects(_sidebarProjectsCache);
        }
      }).catch(() => { });
    };

    const handleProjectUpdate = (payload) => {
      if (String(payload.company_id) !== String(companyId)) return;
      fetchSidebarProjects();
    };

    SocketService.on("project_update", handleProjectUpdate);
    return () => SocketService.off("project_update", handleProjectUpdate);
  }, [openMenuTasksProjects]);

  // Tooltip props disabled
  const tooltipProps = (title) => ({ className: "sidebar-tooltip-trigger" });

  const renderSubMenuItem = (to, icon, text, className = "") => {
    const isLetterIcon = icon && icon.length === 1;
    const isImgIcon = icon && icon.startsWith("/");
    const linkClass = [isActive(to) ? "active" : "", className, isImgIcon ? "task-filter-link" : ""].filter(Boolean).join(" ");
    return (
      <li>
        <Link to={to} className={linkClass} style={isImgIcon ? { display: "flex", alignItems: "center", gap: "8px" } : undefined}>
          {isLetterIcon ? (
            <span className="letter-icon">{icon}</span>
          ) : isImgIcon ? (
            <img src={icon} alt="" className="task-filter-icon" style={{ width: "20px", height: "20px", flexShrink: 0 }} />
          ) : (
            <i className={icon} />
          )}
          <span style={isImgIcon ? { flex: 1 } : undefined}>{text}</span>
        </Link>
      </li>
    );
  };
  return (
    <>
      {/* Mobile sidebar backdrop — closes sidebar when tapped outside */}
      <div
        className="sidebar-overlay-backdrop"
        onClick={() => document.body.classList.remove("sidebar-enable")}
      />

      {/* NUCLEAR OPTION: Inject styles to override vendor CSS !important */}
      <style>
        {`
          /* =============================================================================
             MAXIMUM SPECIFICITY OVERRIDES v3
             Using BOX-SHADOW instead of Border for reliability
             ============================================================================= */

          /* Kill all transitions/animations on every sidebar link and icon */
          #sidebar-menu ul li a,
          #sidebar-menu ul li a:hover,
          #sidebar-menu ul li a:focus,
          #sidebar-menu ul li a:active,
          #sidebar-menu ul li a i,
          #sidebar-menu ul li a:hover i,
          #sidebar-menu ul li a:focus i {
              -webkit-transition: none !important;
              -moz-transition: none !important;
              -o-transition: none !important;
              transition: none !important;
              animation: none !important;
          }

          /* ACTIVE / HOVER — color only, no borders, no backgrounds, no shadows */
          body .vertical-menu #sidebar-menu ul li a,
          body .vertical-menu #sidebar-menu ul li a:hover,
          body .vertical-menu #sidebar-menu ul li a:focus,
          body .vertical-menu #sidebar-menu ul li a:active,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li a,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li a:hover,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li a:focus {
              background-color: transparent !important;
              background: transparent !important;
              box-shadow: none !important;
              outline: none !important;
              border-left: none !important;
          }

          body .vertical-menu #sidebar-menu ul li.mm-active > a,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li.mm-active > a,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active > a,
          body .vertical-menu #sidebar-menu ul li.mm-active > a.parent-active,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li.mm-active > a.parent-active,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active > a.parent-active {
              color: #0DDFAB !important;
              background-color: transparent !important;
              background: transparent !important;
              border-left: none !important;
              box-shadow: none !important;
          }

          body .vertical-menu #sidebar-menu ul li ul.sub-menu li a.active,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li ul.sub-menu li a.active,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a.active,
          body .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li.mm-active > a {
              color: #1D1D1D !important;
              background-color: #f1f3f5 !important;
              border-left: none !important;
              box-shadow: none !important;
              border-radius: 6px !important;
          }

          body .vertical-menu #sidebar-menu ul li.mm-active > a i,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li.mm-active > a i,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active > a i,
          body .vertical-menu #sidebar-menu ul li.mm-active > a .sidebar-icon,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li.mm-active > a .sidebar-icon,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li.mm-active > a .sidebar-icon,
          body .vertical-menu #sidebar-menu ul li ul.sub-menu li a.active i,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li ul.sub-menu li a.active i,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a.active i {
              color: #0DDFAB !important;
          }

          body .vertical-menu #sidebar-menu ul li ul.sub-menu li a,
          body[data-sidebar="dark"] .vertical-menu #sidebar-menu ul li ul.sub-menu li a,
          body[data-sidebar="dark"].vertical-collpsed .vertical-menu #sidebar-menu ul li ul.sub-menu li a {
              border-left: none !important;
              box-shadow: none !important;
          }
          /* Leads icon — white default, teal on hover/active */
          #sidebar-menu li a .leads-icon { color: #fff; opacity: 1; }
          #sidebar-menu li a:hover .leads-icon,
          #sidebar-menu li a:focus .leads-icon { color: #0DDFAB !important; }
          #sidebar-menu li.mm-active > a .leads-icon,
          #sidebar-menu li > a.parent-active .leads-icon { color: #0DDFAB !important; }
          /* HR Module icon — white default, teal on hover/active */
          #sidebar-menu li a .hr-icon { color: #fff; opacity: 1; }
          #sidebar-menu li a:hover .hr-icon,
          #sidebar-menu li a:focus .hr-icon { color: #0DDFAB !important; }
          #sidebar-menu li.mm-active > a .hr-icon,
          #sidebar-menu li > a.parent-active .hr-icon { color: #0DDFAB !important; }
 opacity: 1; }

          /* Task filter SVG icon — grey default, teal on hover/active */
          .task-filter-icon { filter: none !important; opacity: 0.75; }
          .task-filter-link:hover .task-filter-icon,
          .task-filter-link:focus .task-filter-icon,
          .task-filter-link.active .task-filter-icon,
          li a.active .task-filter-icon {
            filter: brightness(0) saturate(100%) invert(57%) sepia(94%) saturate(1297%) hue-rotate(120deg) brightness(95%) contrast(103%) !important;
            opacity: 1;
          }

          /* PendingApproval SVG is colored (green) — grayscale then tune brightness to match other grey icons */
          .task-filter-icon[src*="PendingApproval"] {
            filter: grayscale(1) brightness(0.82) !important;
            opacity: 0.75;
          }
          .task-filter-link:hover .task-filter-icon[src*="PendingApproval"],
          .task-filter-link:focus .task-filter-icon[src*="PendingApproval"],
          .task-filter-link.active .task-filter-icon[src*="PendingApproval"],
          li a.active .task-filter-icon[src*="PendingApproval"] {
            filter: brightness(0) saturate(100%) invert(57%) sepia(94%) saturate(1297%) hue-rotate(120deg) brightness(95%) contrast(103%) !important;
            opacity: 1;
          }

          /* Special handling for WFH to preserve the white foreground details on hover/active */
          .task-filter-link .task-filter-icon[src*="WFH Home"] {
            filter: none !important;
          }
          .task-filter-link:hover .task-filter-icon[src*="WFH Home"],
          .task-filter-link:focus .task-filter-icon[src*="WFH Home"],
          .task-filter-link.active .task-filter-icon[src*="WFH Home"],
          li a.active .task-filter-icon[src*="WFH Home"] {
            content: url("/assets/images/icons/WFH Home Active.svg") !important;
            filter: none !important;
            opacity: 1;
          }
        `}
      </style>
      <Header handleChange={handleChange} sideBarState={sideBarState} />
      <div className="vertical-menu">
        {/* LOGO */}
        <div className="navbar-brand-box">
          {DataParser.CompanyId() === 0 ? (
            <Link
              to={`/${DataParser.CompanyIdentifierRole()}/dashboard`}
              className="logo logo-light"
            >
              <span className="logo-sm">
                <img src="/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src="/assets/images/logo-light.png" alt="" height="20" />
              </span>
            </Link>
          ) : (
            <Link
              to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}
              className="logo logo-light"
            >
              <span className="logo-sm">
                <img src="/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span className="logo-lg">
                <img src="/assets/images/logo-light.png" alt="" height="20" />
              </span>
            </Link>
          )}
        </div>

        <div className="sidebar-menu-scroll">
          {/*- Sidemenu */}
          <div id="sidebar-menu">
            {/* Left Menu Start */}
            <ul className="list-unstyled" id="side-menu">
              {usertype === "user" && !DataParser.IsSaaSAdmin() ? (
                <>
                  <li className="menu-title">General</li>
                  <li className={isActive(`/${DataParser.CompanyIdentifierRole()}/dashboard`) ? "active" : ""}>
                    <Link
                      to={`/${DataParser.CompanyIdentifierRole()}/dashboard`}
                      className={isActive(`/${DataParser.CompanyIdentifierRole()}/dashboard`) ? "active" : ""}
                      {...tooltipProps("Dashboard")}
                    >
                      <i className="uil-home-alt" />
                      <span>Dashboard</span>
                    </Link>
                  </li>

                  {userPermissions.indexOf("package-list") !== -1 ? (
                    <li className={isActive(`/${DataParser.CompanyIdentifierRole()}/packages`) ? "active" : ""}>
                      <Link
                        to={`/${DataParser.CompanyIdentifierRole()}/packages`}
                        className={isActive(`/${DataParser.CompanyIdentifierRole()}/packages`) ? "active" : ""}
                        {...tooltipProps("Packages")}
                      >
                        <i className="uil-home-alt" />
                        <span>Packages</span>
                      </Link>
                    </li>
                  ) : null}
                </>
              ) : (
                (() => {
                  const isSaaSAdmin = DataParser.IsSaaSAdmin();
                  if (isSaaSAdmin) {
                    return (
                      <>
                        <li className="menu-title">SaaS Admin</li>

                        <li
                          className={
                            isActive(
                              `${DataParser.CompanyUrlPrefix()}/saas-admin-dashboard`,
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to={`${DataParser.CompanyUrlPrefix()}/saas-admin-dashboard`}
                            className={
                              isActive(
                                `${DataParser.CompanyUrlPrefix()}/saas-admin-dashboard`,
                              )
                                ? "active"
                                : ""
                            }
                            {...tooltipProps("Dashboard")}
                          >
                            <i className="uil-home-alt" />
                            <span>Dashboard</span>
                          </Link>
                        </li>

                        <li
                          className={
                            isActive(
                              `${DataParser.CompanyUrlPrefix()}/modules`,
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to={`${DataParser.CompanyUrlPrefix()}/modules`}
                            className={
                              isActive(
                                `${DataParser.CompanyUrlPrefix()}/modules`,
                              )
                                ? "active"
                                : ""
                            }
                            {...tooltipProps("Module")}
                          >
                            <i>
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="3"
                                  y="3"
                                  width="7"
                                  height="7"
                                  rx="1.5"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                />
                                <rect
                                  x="14"
                                  y="3"
                                  width="7"
                                  height="7"
                                  rx="1.5"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                />
                                <rect
                                  x="3"
                                  y="14"
                                  width="7"
                                  height="7"
                                  rx="1.5"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                />
                                <rect
                                  x="14"
                                  y="14"
                                  width="7"
                                  height="7"
                                  rx="1.5"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                />
                              </svg>
                            </i>
                            <span>Module</span>
                          </Link>
                        </li>

                        <li
                          className={
                            isActive(
                              `${DataParser.CompanyUrlPrefix()}/packages`,
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to={`${DataParser.CompanyUrlPrefix()}/packages`}
                            className={
                              isActive(
                                `${DataParser.CompanyUrlPrefix()}/packages`,
                              )
                                ? "active"
                                : ""
                            }
                            {...tooltipProps("Package")}
                          >
                            <i>
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M16.5 9.5L5 15L12 19L21 15L16.5 9.5Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M3 12L12 17L21 12"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M12 3L3 7.5L12 12L21 7.5L12 3Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </i>
                            <span>Package</span>
                          </Link>
                        </li>

                        <li
                          className={
                            isActive(
                              `${DataParser.CompanyUrlPrefix()}/companies`,
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to={`${DataParser.CompanyUrlPrefix()}/companies`}
                            className={
                              isActive(
                                `${DataParser.CompanyUrlPrefix()}/companies`,
                              )
                                ? "active"
                                : ""
                            }
                            {...tooltipProps("Company")}
                          >
                            <i>
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  x="2"
                                  y="3"
                                  width="20"
                                  height="19"
                                  rx="2"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                />
                                <path
                                  d="M12 3v19M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                              </svg>
                            </i>
                            <span>Company</span>
                          </Link>
                        </li>

                        <li
                          className={
                            isActive(
                              `${DataParser.CompanyUrlPrefix()}/saas-admin-users`,
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to={`${DataParser.CompanyUrlPrefix()}/saas-admin-users`}
                            className={
                              isActive(
                                `${DataParser.CompanyUrlPrefix()}/saas-admin-users`,
                              )
                                ? "active"
                                : ""
                            }
                            {...tooltipProps("Users")}
                          >
                            <i>
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <circle
                                  cx="9"
                                  cy="7"
                                  r="4"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </i>
                            <span>Users</span>
                          </Link>
                        </li>

                        <li
                          className={
                            isActive(
                              `${DataParser.CompanyUrlPrefix()}/permissions`,
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to={`${DataParser.CompanyUrlPrefix()}/permissions`}
                            className={
                              isActive(
                                `${DataParser.CompanyUrlPrefix()}/permissions`,
                              )
                                ? "active"
                                : ""
                            }
                            {...tooltipProps("Permission")}
                          >
                            <i>
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                />
                                <path
                                  d="M2 12C2 12 5 4 12 4C19 4 22 12 22 12C22 12 19 20 12 20C5 20 2 12 2 12Z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                />
                              </svg>
                            </i>
                            <span>Permission</span>
                          </Link>
                        </li>

                        <li
                          className={
                            isActive(
                              `${DataParser.CompanyUrlPrefix()}/saas-admin-roles`,
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to={`${DataParser.CompanyUrlPrefix()}/saas-admin-roles`}
                            className={
                              isActive(
                                `${DataParser.CompanyUrlPrefix()}/saas-admin-roles`,
                              )
                                ? "active"
                                : ""
                            }
                            {...tooltipProps("Roles")}
                          >
                            <i>
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12 2L3 7v6c0 5.25 3.83 10.15 9 11 5.17-.85 9-5.75 9-11V7l-9-5z"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M12 8v4"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                                <circle
                                  cx="12"
                                  cy="16"
                                  r="0.5"
                                  fill="currentColor"
                                />
                              </svg>
                            </i>
                            <span>Roles</span>
                          </Link>
                        </li>
                      </>
                    );
                  }
                  return (
                <>
                  {/* Chat */}

                  {/* My Attendance */}

                  {userPermissions.indexOf("myattendance-list") !== -1 ? (
                    <li
                      className={
                        isActive(
                          `/${DataParser.CompanyIdentifierRole()}/employee-attendance`
                        )
                          ? "active"
                          : ""
                      }
                    >
                      <Link
                        to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}
                        className={
                          isActive(
                            `/${DataParser.CompanyIdentifierRole()}/employee-attendance`
                          )
                            ? "active"
                            : ""
                        }
                        {...tooltipProps("My Attendance")}
                      >
                        <i><svg width="18" height="21" viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.25544 2.02562C8.13742 1.40687 11.0547 0.69127 14.6644 0.753831C18.2029 0.814678 21.0448 1.60055 22.8916 2.2673" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" /><path d="M0.750046 11.8863C1.25054 11.2093 6.11146 4.86914 14.6635 4.86914C23.2155 4.86914 28.0765 11.2093 28.577 11.8863" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" /><path d="M1.8393 24.7121C1.65847 23.5183 1.18112 19.3858 3.71443 15.3956C3.97153 14.9911 7.9943 8.8901 15.0269 9.28604C20.5948 9.5997 23.7623 13.7442 24.2217 14.3672C24.3905 14.5969 27.4114 18.8108 26.3993 23.3812C25.9374 25.4671 24.975 26.0962 24.7659 26.2247C23.5841 26.9515 22.0509 26.7004 21.0156 26.1039C20.5717 25.8485 20.2417 25.5143 19.8372 24.8064C19.365 23.9819 19.0908 23.0607 19.0025 22.1145C18.8611 20.6071 18.1207 17.9692 14.6635 17.9692C10.2277 17.9692 10.2645 22.2628 10.3014 22.9784C10.3048 23.0435 10.3082 23.1078 10.3108 23.1729C10.3451 24.0882 10.8353 31.4096 17.7487 33.8469" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" /><path d="M10.0965 33.2718C8.87444 31.9143 6.64537 29.0159 6.10375 24.8329C5.85864 22.9389 5.5047 20.2102 7.193 17.5732C9.45463 14.0389 13.5074 13.601 13.7268 13.5804C14.5872 13.5016 17.3116 13.385 19.7155 15.3047C23.0707 17.9828 22.8299 22.2524 22.8008 22.6544" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" /><path d="M14.6232 21.627C14.5787 22.2928 14.5787 23.3478 14.9052 24.5708C15.0826 25.2349 16.0116 28.7067 19.2605 30.0959C20.7679 30.7403 22.2291 30.7035 23.2533 30.5398" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" /></svg></i>
                        <span>My Attendance</span>
                      </Link>
                    </li>
                  ) : null}

                  {/* Tasks & Projects — combined flyout */}
                  {DataParser.AllowedCompanyModules()?.includes("Tasks") && (userPermissions.includes("tasks-list") || userPermissions.includes("project-list")) && (() => {
                    const hasTasks = userPermissions.includes("tasks-list");
                    const hasProjects = userPermissions.includes("project-list");
                    const label = (hasTasks && hasProjects) ? "Tasks & Projects" : hasTasks ? "Tasks" : "Projects";

                    return (
                      <li className={openMenuTasksProjects ? "mm-active" : ""}>
                        <Link
                          to="#"
                          className={`has-arrow ${openMenuTasksProjects ? "parent-active" : ""}`}
                          onClick={(e) => { e.preventDefault(); handleToggleTasksProjects(); }}
                          {...tooltipProps(label)}
                        >
                          <i><svg width="18" height="18" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.75" y="0.75" width="26.5339" height="26.5339" rx="4.25" stroke="currentColor" strokeWidth="1.5" /><path d="M4.87234 9.87869L6.38539 11.3106L9.25893 7.93359" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M4.87234 18.949L6.38539 20.3809L9.25893 17.0039" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M12.8403 9.87305H21.3402" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M12.8403 18.7617H21.3402" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg></i>
                          <span>{label}</span>
                        </Link>
                        <ul className={`sub-menu ${openMenuTasksProjects ? "mm-show" : "mm-collapse"}`}>
                          <li className="submenu-header">
                            <span className="header-text">{label}</span>
                          </li>

                          {/* ── Task Filters Section ── */}
                          {hasTasks && (
                            <div className="submenu-section-container">
                              <div
                                className="submenu-section-header"
                                onClick={() => setOpenSubTasks(!openSubTasks)}
                                style={{ cursor: 'pointer' }}
                              >
                                <div>Tasks</div>
                                <div className="accordion-toggle-icons">
                                  {canCreateTask && (
                                  <div
                                    className="toggle-box"
                                    title="Add task"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const isOnTasks = window.location.pathname.includes('/tasks');
                                      if (isOnTasks) {
                                        window.dispatchEvent(new Event('openCreateTaskModal'));
                                      } else {
                                        document.getElementById('sidebarCreateTaskTrigger')?.click();
                                      }
                                    }}
                                  >
                                    <i className="uil-plus" style={{ fontSize: "14px" }} />
                                  </div>
                                  )}
                                  <div
                                    className="toggle-box"
                                    title="View all tasks"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/${companyRole}/tasks`, { state: { taskFilter: 'due_today' } });
                                    }}
                                  >
                                    <i className="uil-external-link-alt" style={{ fontSize: "14px" }} />
                                  </div>
                                  <div className="toggle-box">
                                    <i className={openSubTasks ? "uil-angle-up" : "uil-angle-down"} />
                                  </div>
                                </div>
                              </div>
                              {openSubTasks && [
                                { key: 'due_today', label: 'Due Today', svg: '/assets/images/icons/Due Today.svg' },
                                { key: 'due_in_7_days', label: 'Due in 7 days', svg: '/assets/images/icons/Due in 7 days.svg' },
                                { key: 'delayed', label: 'Delayed', svg: '/assets/images/icons/Delayed.svg' },
                                { key: 'created_by_me', label: 'Created by me', svg: '/assets/images/icons/Created by me.svg' },
                                { key: 'assigned_to_me', label: 'Assigned to me', svg: '/assets/images/icons/Assigned to me.svg' },
                                { key: 'pending_approval', label: 'Pending Approval', svg: '/assets/images/icons/PendingApproval.svg' },
                              ].map(filter => (
                                <li key={filter.key}>
                                  <a
                                    href="#"
                                    className={`sub-menu-item-link task-filter-link${(location.pathname === `/${companyRole}/tasks` && (location.state?.taskFilter === filter.key || (!location.state?.taskFilter && filter.key === 'due_today'))) ? " active" : ""}`}
                                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigate(`/${companyRole}/tasks`, { state: { taskFilter: filter.key } });
                                    }}
                                  >
                                    <img
                                      src={filter.svg}
                                      alt={filter.label}
                                      className="task-filter-icon"
                                      style={{ width: "20px", height: "20px", flexShrink: 0 }}
                                    />
                                    <span style={{ flex: 1 }}>{filter.label}</span>
                                  </a>
                                </li>
                              ))}
                            </div>
                          )}

                          {/* ── Projects Section ── */}
                          {hasProjects && (
                            <div className="submenu-section-container">
                              <div
                                className="submenu-section-header"
                                onClick={() => setOpenSubProjects(!openSubProjects)}
                                style={{ cursor: 'pointer' }}
                              >
                                <div>Projects</div>
                                <div className="accordion-toggle-icons">
                                  <div
                                    className="toggle-box"
                                    title="Search projects"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setProjectSearchOpen(prev => {
                                        if (prev) setProjectSearch('');
                                        return !prev;
                                      });
                                    }}
                                  >
                                    <i className="uil-search" style={{ fontSize: "14px" }} />
                                  </div>
                                  <div
                                    className="toggle-box"
                                    title="Add project"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const isOnProjects = window.location.pathname.includes('/projects');
                                      if (isOnProjects) {
                                        window.dispatchEvent(new Event('openCreateProjectModal'));
                                      } else {
                                        document.getElementById('sidebarCreateProjectTrigger')?.click();
                                      }
                                    }}
                                  >
                                    <i className="uil-plus" style={{ fontSize: "14px" }} />
                                  </div>
                                  <div
                                    className="toggle-box"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/${companyRole}/projects`);
                                    }}
                                    title="View all projects"
                                  >
                                    <i className="uil-external-link-alt" style={{ fontSize: "14px" }} />
                                  </div>
                                  <div className="toggle-box">
                                    <i className={openSubProjects ? "uil-angle-up" : "uil-angle-down"} />
                                  </div>
                                </div>
                              </div>
                              {projectSearchOpen && (
                                <div style={{ padding: '4px 12px 6px' }} onClick={(e) => e.stopPropagation()}>
                                  <input
                                    autoFocus
                                    type="text"
                                    className="sidebar-project-search"
                                    value={projectSearch}
                                    onChange={(e) => setProjectSearch(e.target.value)}
                                    placeholder="Search projects..."
                                    style={{
                                      width: '100%',
                                      borderRadius: '6px',
                                      padding: '4px 8px',
                                      fontSize: '12px',
                                      color: '#1d1d1d',
                                      background: '#f8f9fa',
                                    }}
                                  />
                                </div>
                              )}
                              {openSubProjects && (() => {
                                const filtered = projectSearch
                                  ? sidebarProjects.filter(p => (p.name || p.project_name || '').toLowerCase().includes(projectSearch.toLowerCase()))
                                  : sidebarProjects;
                                return filtered.length === 0 ? (
                                  <li style={{ padding: "6px 20px", color: "#aaa", fontSize: "12px" }}>{projectSearch ? 'No matches' : 'No projects'}</li>
                                ) : filtered.map(project => {
                                  const projectId = project.id || project._id;
                                  const projectName = project.name || project.project_name || "Unnamed";
                                  const initial = projectName.charAt(0).toUpperCase();
                                  return (
                                    <li key={projectId}>
                                      <a
                                        href="#"
                                        className={`sub-menu-item-link${(location.pathname === `/${companyRole}/projects` && location.state?.openProjectId === projectId) ? " active" : ""}`}
                                        style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate(`/${companyRole}/projects`, { state: { openProjectId: projectId } });
                                        }}
                                      >
                                        <div className="flyout-avatar" style={{ width: 22, height: 22, minWidth: 22, borderRadius: "5px", background: "#0DDFAB", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                          <span style={{ fontSize: 11, fontWeight: 500, color: "#000" }}>{initial}</span>
                                        </div>
                                        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{projectName}</span>
                                      </a>
                                    </li>
                                  );
                                });
                              })()}
                            </div>
                          )}
                        </ul>
                      </li>
                    );
                  })()}

                  {/* Notes — flyout with its tabs (as Tasks) */}
                  {DataParser.AllowedCompanyModules()?.includes("Notes") && userPermissions.includes("notes-list") && (
                    <li className={[openMenuNotes && "mm-active", isActive(notesPath) && "active"].filter(Boolean).join(" ") || undefined}>
                      <Link
                        to="#"
                        className={["has-arrow", openMenuNotes && "parent-active", isActive(notesPath) && "active"].filter(Boolean).join(" ")}
                        onClick={(e) => { e.preventDefault(); handleToggleMeetingsNotes(notesPath, openMenuNotes); }}
                        {...tooltipProps("Notes")}
                      >
                        <i><svg width="18" height="18" viewBox="1.2 1.2 21.4 21.4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round" /><path d="M2 6h4M2 10h4M2 14h4M2 18h4" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" /><path d="M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round" /></svg></i>
                        <span>Notes</span>
                      </Link>
                      <ul className={`sub-menu ${openMenuNotes ? "mm-show" : "mm-collapse"}`}>
                        <li className="submenu-header">
                          <span className="header-text">Notes</span>
                        </li>
                        <div className="submenu-section-container">
                          <div className="submenu-section-header" onClick={() => setOpenSubNotes(!openSubNotes)} style={{ cursor: "pointer" }}>
                            <div>Notes</div>
                            <div className="accordion-toggle-icons">
                              {userPermissions.includes("notes-create") && (
                                <div
                                  className="toggle-box"
                                  title="Add note"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (isActive(notesPath)) window.dispatchEvent(new Event("openCreateNoteModal"));
                                    else navigate(notesPath, { state: { view: "active", openCreate: true } });
                                  }}
                                >
                                  <i className="uil-plus" style={{ fontSize: "14px" }} />
                                </div>
                              )}
                              <div className="toggle-box" title="View all notes" onClick={(e) => { e.stopPropagation(); navigate(notesPath, { state: { view: "active" } }); }}>
                                <i className="uil-external-link-alt" style={{ fontSize: "14px" }} />
                              </div>
                              <div className="toggle-box">
                                <i className={openSubNotes ? "uil-angle-up" : "uil-angle-down"} />
                              </div>
                            </div>
                          </div>
                          {openSubNotes && NOTE_TABS.filter((t) => !t.perm || userPermissions.includes(t.perm)).map((t) => (
                            <li key={t.key}>
                              <a
                                href="#"
                                className={`sub-menu-item-link${location.pathname === notesPath && (location.state?.view === t.key || (!location.state?.view && t.key === "active")) ? " active" : ""}`}
                                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                onClick={(e) => { e.preventDefault(); navigate(notesPath, { state: { view: t.key } }); }}
                              >
                                <i className={t.icon} />
                                <span style={{ flex: 1 }}>{t.label}</span>
                              </a>
                            </li>
                          ))}
                        </div>
                      </ul>
                    </li>
                  )}

                  {/* Meetings — flyout with its tabs (as Tasks), incl. Due in 7 days */}
                  {DataParser.AllowedCompanyModules()?.includes("Meetings") && userPermissions.includes("meetings-list") && (
                    <li className={[openMenuMeetings && "mm-active", isActive(meetingsPath) && "active"].filter(Boolean).join(" ") || undefined}>
                      <Link
                        to="#"
                        className={["has-arrow", openMenuMeetings && "parent-active", isActive(meetingsPath) && "active"].filter(Boolean).join(" ")}
                        onClick={(e) => { e.preventDefault(); handleToggleMeetingsNotes(meetingsPath, openMenuMeetings); }}
                        {...tooltipProps("Meetings")}
                      >
                        <i><svg width="18" height="18" viewBox="1.95 1.45 21.1 21.1" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 2v4M8 2v4M3 10h5" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" /><path d="M17.5 17.5 16 16.3V14" stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" strokeLinejoin="round" /><circle cx="16" cy="16" r="6" stroke="currentColor" strokeWidth="1.15" /></svg></i>
                        <span>Meetings</span>
                      </Link>
                      <ul className={`sub-menu ${openMenuMeetings ? "mm-show" : "mm-collapse"}`}>
                        <li className="submenu-header">
                          <span className="header-text">Meetings</span>
                        </li>
                        <div className="submenu-section-container">
                          <div className="submenu-section-header" onClick={() => setOpenSubMeetings(!openSubMeetings)} style={{ cursor: "pointer" }}>
                            <div>Meetings</div>
                            <div className="accordion-toggle-icons">
                              {userPermissions.includes("meetings-create") && (
                                <div
                                  className="toggle-box"
                                  title="Add meeting"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (location.pathname === meetingsPath) window.dispatchEvent(new Event("openCreateMeetingModal"));
                                    else navigate(meetingsPath, { state: { meetingView: "upcoming", openCreate: true } });
                                  }}
                                >
                                  <i className="uil-plus" style={{ fontSize: "14px" }} />
                                </div>
                              )}
                              <div className="toggle-box" title="View all meetings" onClick={(e) => { e.stopPropagation(); navigate(meetingsPath, { state: { meetingView: "all" } }); }}>
                                <i className="uil-external-link-alt" style={{ fontSize: "14px" }} />
                              </div>
                              <div className="toggle-box">
                                <i className={openSubMeetings ? "uil-angle-up" : "uil-angle-down"} />
                              </div>
                            </div>
                          </div>
                          {openSubMeetings && MEETING_TABS.filter((t) => !t.perm || userPermissions.includes(t.perm)).map((t) => (
                            <li key={t.key}>
                              <a
                                href="#"
                                className={`sub-menu-item-link${location.pathname === meetingsPath && (location.state?.meetingView === t.key || (!location.state?.meetingView && t.key === "all")) ? " active" : ""}`}
                                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                onClick={(e) => { e.preventDefault(); navigate(meetingsPath, { state: { meetingView: t.key } }); }}
                              >
                                <i className={t.icon} />
                                <span style={{ flex: 1 }}>{t.label}</span>
                              </a>
                            </li>
                          ))}
                        </div>
                      </ul>
                    </li>
                  )}

                  {/* Leads — flyout with Leads, Pipeline Board, Action Queue */}
                  {DataParser.AllowedCompanyModules()?.includes("Leads") && userPermissions.indexOf("leads-list") !== -1 ? (
                    <li className={openMenuLeadsCrm ? "mm-active" : ""}>
                      <Link
                        to="#"
                        className={`has-arrow ${openMenuLeadsCrm ? "parent-active" : ""}`}
                        onClick={(e) => { e.preventDefault(); handleToggleLeadsCrm(); }}
                        {...tooltipProps("Leads")}
                      >
                        <i><svg xmlns="http://www.w3.org/2000/svg" className="leads-icon" width={20} height={20} viewBox="0 0 32 32" fill="none"><path d="M14.742 5.137l-1.484 3.956a1 1 0 00.936 1.351h1.899a1 1 0 01.966 1.26l-1.097 4.091" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" /><circle cx={4.1921} cy={3.60211} r={3.60211} fill="currentColor" /><circle cx={26.1152} cy={3.60211} r={3.60211} fill="currentColor" /><path d="M.75 10.785h7.417l.059 4.94a7.171 7.171 0 0014.342-.086v-5.285h8.208v5.364c0 8.291-6.721 15.013-15.013 15.013C7.472 30.731.75 24.009.75 15.718v-4.933zM.755 16.016h7.474M22.987 16.016h7.474" stroke="currentColor" strokeWidth={1.5} /></svg></i>
                        <span>Leads</span>
                      </Link>
                      <ul className={`sub-menu ${openMenuLeadsCrm ? "mm-show" : "mm-collapse"}`}>
                        <li>
                          <div className="submenu-section-header" style={{ cursor: 'default' }}>
                            <div style={{ fontSize: '14px', fontWeight: 600 }}>Leads</div>
                            <div className="accordion-toggle-icons">
                              <div
                                className="toggle-box"
                                title="Add lead"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const isOnLeads = ['leads', 'crm-leads', 'crm-pipeline', 'crm-action-queue'].some(s => window.location.pathname.includes(s));
                                  if (isOnLeads) {
                                    window.dispatchEvent(new Event('openCreateLeadModal'));
                                  } else {
                                    setShowSidebarCreateLead(true);
                                  }
                                }}
                              >
                                <i className="uil-plus" />
                              </div>
                            </div>
                          </div>
                        </li>
                        {[
                          // { label: "Leads", path: `/${companyRole}/leads` },
                          // { label: "Pipeline Board", path: `/${companyRole}/crm-pipeline` },
                          // { label: "Action Queue", path: `/${companyRole}/crm-action-queue` },
                          { label: "Leads", path: `/${companyRole}/leads`, icon: "uil-list-ul" },
                          { label: "Pipeline Board", path: `/${companyRole}/crm-pipeline`, icon: "uil-columns" },
                          { label: "Action Queue", path: `/${companyRole}/crm-action-queue`, icon: "uil-layers-slash" },
                        ].map(item => (
                          <li key={item.path}>
                            <Link
                              to={item.path}
                              className={`sub-menu-item-link task-filter-link${isActive(item.path) ? " active" : ""}`}
                              style={{ display: "flex", alignItems: "center", gap: "8px" }}
                            >
                              <img
                                src={`/assets/images/icons/${item.label}.svg`}
                                alt={item.label}
                                className="task-filter-icon"
                                style={{ width: "20px", height: "20px", flexShrink: 0 }}
                              />
                              <span style={{ flex: 1 }}>{item.label}</span>
                            </Link>
                          </li>
                        ))}
                        {/* Dashboard — company admin only */}
                        {(DataParser.userRoleTitle() || "").toLowerCase() === "company admin" && (
                          <li>
                            <Link
                              to={`/${companyRole}/lead-dashboard`}
                              className={`sub-menu-item-link task-filter-link${isActive(`/${companyRole}/lead-dashboard`) ? " active" : ""}`}
                              style={{ display: "flex", alignItems: "center", gap: "8px" }}
                            >
                              <svg
                                className="task-filter-icon"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                style={{ flexShrink: 0, color: "#8a929b" }}
                              >
                                <rect x="3" y="3" width="8" height="8" rx="1.5" fill="currentColor" opacity="0.85"/>
                                <rect x="13" y="3" width="8" height="8" rx="1.5" fill="currentColor" opacity="0.85"/>
                                <rect x="3" y="13" width="8" height="8" rx="1.5" fill="currentColor" opacity="0.85"/>
                                <rect x="13" y="13" width="8" height="8" rx="1.5" fill="currentColor" opacity="0.85"/>
                              </svg>
                              <span style={{ flex: 1 }}>Dashboard</span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    </li>
                  ) : null}

                  {/* Merged Leaves & Work From Home Module (Parent) */}
                  {(userPermissions.includes("myleave-list") ||
                    userPermissions.includes("myteamleavesrequest-list") ||
                    userPermissions.includes("mywfh-list") ||
                    userPermissions.includes("myteamwfhrequest-list") ||
                    userPermissions.includes("hrwfhrequest-list")) && (() => {
                      const isMergedActive = isParentActive([...leavesPaths, ...wfhPaths]);
                      return (
                        <li className={(isMergedActive || openMenuLeaves) ? "mm-active" : ""}>
                          <Link
                            to="#"
                            className={`has-arrow ${isMergedActive ? "parent-active" : ""}`}
                            onClick={(e) => {
                              e.preventDefault();
                              handleToogleMenuLeaves();
                            }}
                            {...tooltipProps("Leaves & WFH")}
                          >
                            <i><svg width="18" height="16" viewBox="0 0 34 31" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.75" y="4.36133" width="32.3478" height="25.3721" rx="4.25" stroke="currentColor" strokeWidth="1.5" /><path d="M0.170654 10.4473H33.6772" stroke="currentColor" strokeWidth="1.5" /><path d="M6.89526 0.75V6.37457" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M13.581 0.75V6.37457" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M20.2669 0.75V6.37457" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M26.9526 0.75V6.37457" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M9.25481 13.8027L5.27515 17.7824" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M5.2753 13.8027L9.25497 17.7824" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M18.9138 13.8027L14.9341 17.7824L13.779 16.1635" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M28.5727 13.8027L24.593 17.7824" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M24.593 13.8027L28.5727 17.7824" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M9.25499 22.0137L5.27532 25.9933L4.14587 24.4206" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M18.9138 22.0137L14.9342 25.9933" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M14.9341 22.0137L18.9138 25.9933" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M28.5726 22.0137L24.5929 25.9933L23.1827 24.2486" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg></i>
                            <span>Leaves & WFH</span>
                          </Link>
                          <ul className={`sub-menu ${openMenuLeaves ? "mm-show" : "mm-collapse"}`}>
                            <li className="submenu-header">
                              <span className="header-text">Leaves & WFH</span>
                            </li>

                            {/* Leaves Section Accordion */}
                            {(userPermissions.includes("myleave-list") || userPermissions.includes("myteamleavesrequest-list")) && (
                              <div className="submenu-section-container">
                                <div
                                  className="submenu-section-header"
                                  onClick={() => setOpenSubLeaves(!openSubLeaves)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <div>Leaves</div>
                                  <div className="accordion-toggle-icons">
                                    <div className="toggle-box">
                                      <i className={openSubLeaves ? "uil-angle-up" : "uil-angle-down"} />
                                    </div>
                                  </div>
                                </div>
                                {openSubLeaves && (
                                  <>
                                    {userPermissions.includes("myleave-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/employee_leaves`, "/assets/images/icons/Leave Requests.svg", "My Leaves", "sub-menu-item-link")}
                                    {userPermissions.includes("myteamleavesrequest-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/leaves_team`, "/assets/images/icons/All Employee.svg", "Team Leaves", "sub-menu-item-link")}
                                  </>
                                )}
                              </div>
                            )}

                            {/* WFH Section Accordion */}
                            {(userPermissions.includes("mywfh-list") || userPermissions.includes("myteamwfhrequest-list") || userPermissions.includes("hrwfhrequest-list")) && (
                              <div className="submenu-section-container">
                                <div
                                  className="submenu-section-header"
                                  onClick={() => setOpenSubWfh(!openSubWfh)}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <div>Work From Home</div>
                                  <div className="accordion-toggle-icons">
                                    <div className="toggle-box">
                                      <i className={openSubWfh ? "uil-angle-up" : "uil-angle-down"} />
                                    </div>
                                  </div>
                                </div>
                                {openSubWfh && (
                                  <>
                                    {userPermissions.includes("mywfh-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/employee_wfh`, "/assets/images/icons/WFH Home.svg", "My WFH", "sub-menu-item-link")}
                                    {userPermissions.includes("myteamwfhrequest-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/wfh_approvals`, "/assets/images/icons/All Employee.svg", "Team WFH", "sub-menu-item-link")}
                                  </>
                                )}
                              </div>
                            )}
                          </ul>
                        </li>
                      );
                    })()}

                  {/* Chat */}
                  {userPermissions.indexOf("chat-list") !== -1 ? (
                    <li className={openMenuChat ? "mm-active" : ""}>
                      <Link
                        to="#"
                        id="main-sidebar-chat-link"
                        className={`has-arrow ${openMenuChat ? "parent-active" : ""}`}
                        onClick={(e) => { e.preventDefault(); handleToggleChat(e); }}
                        {...tooltipProps("Chat")}
                      >
                        {/* <i><svg width="18" height="18" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7666 0.75C22.5077 0.750035 28.7832 7.0255 28.7832 14.7666C28.7832 22.5077 22.5077 28.7832 14.7666 28.7832H0.75V14.7666C0.75 7.02548 7.02548 0.75 14.7666 0.75Z" stroke="currentColor" strokeWidth="1.5" /><path d="M7.59097 12.002H21.77" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M7.59097 17.4863H15.7506" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg></i> */}
                        <i style={{ position: "relative", display: "inline-flex" }}>
                          <svg width="18" height="18" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.7666 0.75C22.5077 0.750035 28.7832 7.0255 28.7832 14.7666C28.7832 22.5077 22.5077 28.7832 14.7666 28.7832H0.75V14.7666C0.75 7.02548 7.02548 0.75 14.7666 0.75Z" stroke="currentColor" strokeWidth="1.5" /><path d="M7.59097 12.002H21.77" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M7.59097 17.4863H15.7506" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
                          {unreadRoomsCount > 0 && (
                            <span style={{
                              position: "absolute", top: -5, right: -7,
                              background: "#1d1d1d", color: "#0DDFAB",
                              borderRadius: "50%", minWidth: 15, height: 15,
                              fontSize: 9, fontWeight: 700, lineHeight: "15px",
                              textAlign: "center", padding: "0 3px",
                              pointerEvents: "none",
                            }}>
                              {unreadRoomsCount > 99 ? "99+" : unreadRoomsCount}
                            </span>
                          )}
                        </i>
                        <span>Chat</span>
                      </Link>
                      <ul className={`sub-menu ${openMenuChat ? "mm-show" : "mm-collapse"}`}>
                        <li className="submenu-header">
                          <span className="header-text">Chat</span>
                        </li>

                        {/* ── Room menu styles ── */}
                        <style>{`
                          .room-menu-btn { display:flex; align-items:center; justify-content:center; flex-shrink:0; background:none; border:none; cursor:pointer; padding:0; width:22px; height:22px; border-radius:6px; color:#8a929b; opacity:0; pointer-events:none; transition:opacity 0.15s; }
                          .chat-item-link:hover .room-menu-btn, .room-menu-btn.open { opacity:1 !important; pointer-events:all !important; }
                          .room-menu-btn:hover { background:none !important; }
                          @keyframes dropdown-in { from { pointer-events:none; } to { pointer-events:all; } }
                          .room-menu-dropdown { position:absolute; right:0; top:calc(100% + 4px); z-index:99999; background:#fff; border:1px solid #ebebeb; border-radius:9px; box-shadow:0 6px 18px rgba(0,0,0,0.12); min-width:160px; padding:4px 0; animation:dropdown-in 0.25s forwards; }
                          .room-menu-item { display:flex; align-items:center; gap:6px; padding:3px 10px; font-size:11px; color:#1d1d1d; cursor:pointer; white-space:nowrap; background:transparent; }
                          .room-menu-dropdown .room-menu-item i,
                          .room-menu-dropdown .room-menu-item span,
                          .room-menu-dropdown .room-menu-item:hover i,
                          .room-menu-dropdown .room-menu-item:hover span,
                          .room-menu-dropdown .room-menu-item:focus i,
                          .room-menu-dropdown .room-menu-item:active i,
                          .sub-menu-item-link:hover .room-menu-dropdown .room-menu-item i,
                          .sub-menu-item-link:hover .room-menu-dropdown .room-menu-item span { color:#6b7280 !important; transition:none !important; }
                          .room-menu-item:hover { background:#f0fdf9; }
                          .room-menu-item.danger { color:#ef4444; }
                          .room-menu-dropdown .room-menu-item.danger i,
                          .room-menu-dropdown .room-menu-item.danger span,
                          .room-menu-dropdown .room-menu-item.danger:hover i,
                          .room-menu-dropdown .room-menu-item.danger:hover span,
                          .sub-menu-item-link:hover .room-menu-dropdown .room-menu-item.danger i,
                          .sub-menu-item-link:hover .room-menu-dropdown .room-menu-item.danger span { color:#ef4444 !important; }
                          .room-menu-item.danger:hover { background:#fff0f0; }
                        `}</style>

                        {/* Channels — standalone only (no parent_id) */}
                        <div className="submenu-section-container">
                          <div className="submenu-section-header" onClick={() => setIsChannelsOpen(!isChannelsOpen)} style={{ cursor: 'pointer' }}>
                            <div>Channels</div>
                            <div className="accordion-toggle-icons">
                              <div className="toggle-box" title="Search channels" onClick={(e) => { e.stopPropagation(); setChannelSearchOpen(prev => { if (prev) setChannelSearch(''); return !prev; }); }}>
                                <i className="uil-search" style={{ fontSize: '14px', color: channelSearchOpen ? '#0DDFAB' : undefined }} />
                              </div>
                              <div className="toggle-box" onClick={(e) => { e.stopPropagation(); openNewChannel(e.currentTarget.getBoundingClientRect()); }}>
                                <i className="uil-plus" style={{ fontSize: '14px' }} />
                              </div>
                              {rooms.filter(r => r.type === "channel" && r.parent_id == null).length > 0 && (
                                <div className="toggle-box">
                                  <i className={isChannelsOpen ? "uil-angle-up" : "uil-angle-down"} />
                                </div>
                              )}
                            </div>
                          </div>
                          {channelSearchOpen && (
                            <div ref={channelSearchRef} style={{ padding: '4px 12px 6px' }} onClick={e => e.stopPropagation()}>
                              <input autoFocus type="text" className="sidebar-project-search" value={channelSearch} onChange={e => setChannelSearch(e.target.value)} onKeyDown={e => { if (e.key === 'Escape') { setChannelSearchOpen(false); setChannelSearch(''); } }} placeholder="Search channels..." style={{ width: '100%', borderRadius: '6px', padding: '4px 8px', fontSize: '12px', color: '#1d1d1d', background: '#f8f9fa' }} />
                            </div>
                          )}
                          {isChannelsOpen && sortByUnread(rooms.filter(r => r.type === "channel" && r.parent_id == null && (!channelSearch || (r.name || '').toLowerCase().includes(channelSearch.toLowerCase())))).map(room => (
                            <li key={room._id} style={{ listStyle: "none" }}>
                              <a
                                href="#"
                                className={`sub-menu-item-link chat-item-link${activeRoom?._id === room._id ? " active" : ""}`}
                                onClick={(e) => { e.preventDefault(); openChat(room, e.currentTarget.getBoundingClientRect()); }}
                                style={{ display: "flex", alignItems: "center", gap: "8px", opacity: room.isPendingInvite ? 0.55 : 1 }}
                                title={room.isPendingInvite ? `${room.inviterName ? `${room.inviterName} invited you` : "Channel Invitation"} - Click to accept` : undefined}
                              >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, overflow: 'hidden', minWidth: 0, opacity: room.is_muted ? 0.45 : 1 }}>
                                  <div className="flyout-avatar" style={{ width: 22, height: 22, minWidth: 22, borderRadius: '5px', background: '#0DDFAB', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                    <span style={{ fontSize: 10, fontWeight: 500, color: '#000' }}>{getChatRoomName(room).charAt(0).toUpperCase()}</span>
                                  </div>
                                  <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {getChatRoomName(room)}
                                  </span>
                                  {room.isPendingInvite && (
                                    <span style={{ fontSize: 9, fontWeight: 600, textTransform: "uppercase", color: "#6b7280", background: "#f3f4f6", padding: "1px 5px", borderRadius: 4, letterSpacing: "0.3px", flexShrink: 0, lineHeight: "14px" }}>
                                      Invite
                                    </span>
                                  )}
                                  {room.unreadCount > 0 && !room.isPendingInvite && (
                                    <span className="unread-badge-hover">
                                      {room.unreadCount > 9 ? "9+" : room.unreadCount}
                                    </span>
                                  )}
                                </div>
                                {!room.isPendingInvite && (
                                  <div style={{ position: "relative", flexShrink: 0 }} onClick={e => e.stopPropagation()}>
                                    <button
                                      className={`room-menu-btn${roomMenuOpenId === room._id ? " open" : ""}`}
                                      onClick={e => openRoomMenu(e, room._id)}
                                    >
                                      <i className="uil-ellipsis-v" style={{ fontSize: 14 }} />
                                    </button>
                                  </div>
                                )}
                              </a>
                            </li>
                          ))}
                        </div>

                        {/* Project Channels — projects as accordion headers, channels as sub-items */}
                        {userPermissions.includes("project-list") && (
                          <div className="submenu-section-container">
                            <div className="submenu-section-header" onClick={() => setOpenSubProjectChannels(!openSubProjectChannels)} style={{ cursor: 'pointer' }}>
                              <div>Project Channels</div>
                              <div className="accordion-toggle-icons">
                                <div className="toggle-box" title="Search project channels" onClick={(e) => { e.stopPropagation(); setProjectChannelSearchOpen(prev => { if (prev) setProjectChannelSearch(''); return !prev; }); }}>
                                  <i className="uil-search" style={{ fontSize: '14px', color: projectChannelSearchOpen ? '#0DDFAB' : undefined }} />
                                </div>
                                {rooms.filter(r => r.type === "project").length > 0 && (
                                  <div className="toggle-box">
                                    <i className={openSubProjectChannels ? "uil-angle-up" : "uil-angle-down"} />
                                  </div>
                                )}
                              </div>
                            </div>
                            {projectChannelSearchOpen && (
                              <div ref={projectChannelSearchRef} style={{ padding: '4px 12px 6px' }} onClick={e => e.stopPropagation()}>
                                <input autoFocus type="text" className="sidebar-project-search" value={projectChannelSearch} onChange={e => setProjectChannelSearch(e.target.value)} onKeyDown={e => { if (e.key === 'Escape') { setProjectChannelSearchOpen(false); setProjectChannelSearch(''); } }} placeholder="Search project channels..." style={{ width: '100%', borderRadius: '6px', padding: '4px 8px', fontSize: '12px', color: '#1d1d1d', background: '#f8f9fa' }} />
                              </div>
                            )}
                            {openSubProjectChannels && rooms.filter(r => r.type === "project" && (!projectChannelSearch || (r.name || '').toLowerCase().includes(projectChannelSearch.toLowerCase()))).map(projRoom => {
                              const projKey = projRoom.id || projRoom._id;
                              const isProjectCollapsed = collapsedProjects[projKey];
                              const subChannels = sortByUnread(rooms.filter(r => r.type === "channel" && r.parent_id != null && String(r.parent_id) === String(projRoom.id)));
                              const hasActiveChild = subChannels.some(s => activeRoom?._id === s._id);
                              return (
                                <div key={projRoom._id}>
                                  {/* Project accordion row */}
                                  <div
                                    className="submenu-section-header"
                                    style={{ cursor: "pointer", paddingLeft: "12px", paddingRight: "12px" }}
                                    onClick={() => setCollapsedProjects(prev => ({ ...prev, [projKey]: !prev[projKey] }))}
                                  >
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, overflow: "hidden" }}>
                                      <div className="flyout-avatar" style={{ width: 22, height: 22, minWidth: 22, borderRadius: "5px", background: "#0DDFAB", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                        <span style={{ fontSize: 10, fontWeight: 500, color: "#000" }}>{(projRoom.name || "P").charAt(0).toUpperCase()}</span>
                                      </div>
                                      <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontWeight: 500 }}>
                                        {projRoom.name}
                                      </span>
                                    </div>
                                    <div className="accordion-toggle-icons">
                                      <div className="toggle-box" onClick={(e) => {
                                        e.stopPropagation();
                                        openNewChannel(e.currentTarget.getBoundingClientRect());
                                      }}>
                                        <i className="uil-plus" style={{ fontSize: "14px" }} />
                                      </div>
                                      <div className="toggle-box">
                                        <i className={isProjectCollapsed ? "uil-angle-down" : "uil-angle-up"} />
                                      </div>
                                    </div>
                                  </div>
                                  {/* Sub-channels */}
                                  {!isProjectCollapsed && (
                                    <div style={{ paddingLeft: "20px" }}>
                                      {subChannels.map(sub => (
                                        <li key={sub._id} style={{ listStyle: "none" }}>
                                          <a
                                            href="#"
                                            className={`sub-menu-item-link chat-item-link${activeRoom?._id === sub._id ? " active" : ""}`}
                                            onClick={(e) => { e.preventDefault(); openChat(sub, e.currentTarget.getBoundingClientRect()); }}
                                            style={{ display: "flex", alignItems: "center", gap: "8px", opacity: sub.isPendingInvite ? 0.55 : 1 }}
                                            title={sub.isPendingInvite ? `${sub.inviterName ? `${sub.inviterName} invited you` : "Channel Invitation"} - Click to accept` : undefined}
                                          >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, overflow: 'hidden', minWidth: 0, opacity: sub.is_muted ? 0.45 : 1 }}>
                                              <div className="flyout-avatar" style={{ width: 22, height: 22, minWidth: 22, borderRadius: "5px", background: "#0DDFAB", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                <span style={{ fontSize: 10, fontWeight: 500, color: "#000" }}>{(sub.name || "#").charAt(0).toUpperCase()}</span>
                                              </div>
                                              <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {sub.name}
                                              </span>
                                              {sub.isPendingInvite && (
                                                <span style={{ fontSize: 9, fontWeight: 600, textTransform: "uppercase", color: "#6b7280", background: "#f3f4f6", padding: "1px 5px", borderRadius: 4, letterSpacing: "0.3px", flexShrink: 0, lineHeight: "14px" }}>
                                                  Invite
                                                </span>
                                              )}
                                              {sub.unreadCount > 0 && !sub.isPendingInvite && (
                                                <span className="unread-badge-hover">{sub.unreadCount > 9 ? "9+" : sub.unreadCount}</span>
                                              )}
                                            </div>
                                            {!sub.isPendingInvite && (
                                              <div style={{ position: "relative", flexShrink: 0 }} onClick={e => e.stopPropagation()}>
                                                <button
                                                  className={`room-menu-btn${roomMenuOpenId === sub._id ? " open" : ""}`}
                                                  onClick={e => openRoomMenu(e, sub._id)}
                                                >
                                                  <i className="uil-ellipsis-v" style={{ fontSize: 14 }} />
                                                </button>
                                              </div>
                                            )}
                                          </a>
                                        </li>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}

                         {/* Inbox (Direct Messages) — shown below Channels */}
                        <div className="submenu-section-container">
                          <div className="submenu-section-header" onClick={() => setIsInboxOpen(!isInboxOpen)} style={{ cursor: 'pointer' }}>
                            <div>Inbox</div>
                            <div className="accordion-toggle-icons">
                              <div className="toggle-box" title="Search inbox" onClick={(e) => { e.stopPropagation(); setInboxSearchOpen(prev => { if (prev) setInboxSearch(''); return !prev; }); }}>
                                <i className="uil-search" style={{ fontSize: '14px', color: inboxSearchOpen ? '#0DDFAB' : undefined }} />
                              </div>
                              <div className="toggle-box" onClick={(e) => { e.stopPropagation(); openNewDm(e.currentTarget.getBoundingClientRect()); }}>
                                <i className="uil-plus" style={{ fontSize: '14px' }} />
                              </div>
                              {rooms.filter(r => r.type === "direct").length > 0 && (
                                <div className="toggle-box">
                                  <i className={isInboxOpen ? "uil-angle-up" : "uil-angle-down"} />
                                </div>
                              )}
                            </div>
                          </div>
                          {inboxSearchOpen && (
                            <div ref={inboxSearchRef} style={{ padding: '4px 12px 6px' }} onClick={e => e.stopPropagation()}>
                              <input autoFocus type="text" className="sidebar-project-search" value={inboxSearch} onChange={e => setInboxSearch(e.target.value)} onKeyDown={e => { if (e.key === 'Escape') { setInboxSearchOpen(false); setInboxSearch(''); } }} placeholder="Search inbox..." style={{ width: '100%', borderRadius: '6px', padding: '4px 8px', fontSize: '12px', color: '#1d1d1d', background: '#f8f9fa' }} />
                            </div>
                          )}
                          {isInboxOpen && sortByUnread(rooms.filter(r => r.type === "direct" && (!inboxSearch || (() => { const other = r.members?.find(m => String(m.id || m._id) !== String(currentUserId)); const name = other ? `${other.first_name || ''} ${other.last_name || ''}`.trim() : (r.name || ''); return name.toLowerCase().includes(inboxSearch.toLowerCase()); })()))).map(room => (
                            <li key={room._id} style={{ listStyle: "none" }}>
                              <a
                                href="#"
                                className={`sub-menu-item-link chat-item-link${activeRoom?._id === room._id ? " active" : ""}`}
                                onClick={(e) => { e.preventDefault(); openChat(room, e.currentTarget.getBoundingClientRect()); }}
                                style={{ display: "flex", alignItems: "center", gap: "8px" }}
                              >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, overflow: 'hidden', minWidth: 0, opacity: room.is_muted ? 0.45 : 1 }}>
                                  {(() => {
                                    const other = room.members?.find(m => String(m.id || m._id) !== String(currentUserId));
                                    const deleted = isDeletedMember(other);
                                    const url = deleted ? null : getImgUrl(other?.image);
                                    // the picture loaded with the login token over the initial; a click on it opens it
                                    return (
                                      <PictureBadge as="div" image={url} className="flyout-avatar" style={{ width: 22, height: 22, minWidth: 22, borderRadius: '5px', background: deleted ? '#9ca3af' : '#0DDFAB', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden', position: 'relative' }}>
                                        <span style={{ fontSize: 10, fontWeight: 500, color: deleted ? '#fff' : '#000', pointerEvents: 'none' }}>{deleted ? "D" : (other?.first_name?.charAt(0).toUpperCase() || "?")}</span>
                                      </PictureBadge>
                                    );
                                  })()}
                                  <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {getChatRoomName(room)}
                                  </span>
                                  {room.unreadCount > 0 && (
                                    <span className="unread-badge-hover">
                                      {room.unreadCount > 9 ? "9+" : room.unreadCount}
                                    </span>
                                  )}
                                </div>
                                <div style={{ position: "relative", flexShrink: 0 }} onClick={e => e.stopPropagation()}>
                                  <button
                                    className={`room-menu-btn${roomMenuOpenId === room._id ? " open" : ""}`}
                                    onClick={e => openRoomMenu(e, room._id)}
                                  >
                                    <i className="uil-ellipsis-v" style={{ fontSize: 14 }} />
                                  </button>
                                </div>
                              </a>
                            </li>
                          ))}
                        </div>

                        {/* New Chat button */}
                        {/* <li style={{ padding: "10px 16px 6px" }}>
                          <a
                            href="#"
                            onClick={(e) => { e.preventDefault(); openChat(null); }}
                            style={{ display: "flex", alignItems: "center", gap: "6px", color: "#0DDFAB", fontWeight: 500, fontSize: "12px" }}
                          >
                            <i className="uil-plus-circle" style={{ fontSize: "15px" }} />
                            New Chat
                          </a>
                        </li> */}
                      </ul>
                    </li>
                  ) : null}

                  {/* Performance Evaluation Module (Parent) */}
                  {(userPermissions.includes("Userevaluation-list") || userPermissions.includes("myevaluation-list")) && (() => {
                    const isPerfActive = isParentActive(performancePaths);
                    return (
                      <li className={`perf-eval-item${(isPerfActive || openMenu4) ? " mm-active" : ""}`}>
                        <Link
                          to="#"
                          className={`has-arrow ${isPerfActive ? "parent-active" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleToogleMenu4();
                          }}
                          {...tooltipProps("Performance Evaluation")}
                        >
                          <i><svg width="18" height="18" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.30801 15.1301C1.90084 15.2061 1.6324 15.5978 1.70843 16.005C1.78447 16.4122 2.17619 16.6806 2.58336 16.6046L2.44569 15.8673L2.30801 15.1301ZM27.0586 0.619287C26.9864 0.211413 26.5973 -0.0607123 26.1894 0.0114784L19.5427 1.18789C19.1348 1.26008 18.8627 1.64925 18.9349 2.05713C19.0071 2.465 19.3963 2.73713 19.8041 2.66494L25.7123 1.61923L26.758 7.52741C26.8302 7.93528 27.2194 8.20741 27.6272 8.13522C28.0351 8.06303 28.3072 7.67386 28.2351 7.26598L27.0586 0.619287ZM2.44569 15.8673L2.58336 16.6046C7.7911 15.6321 19.9223 11.2084 26.9348 1.17979L26.3201 0.75L25.7055 0.320214C19.0017 9.90738 7.30144 14.1976 2.30801 15.1301L2.44569 15.8673Z" fill="currentColor" /><rect x="0.75" y="21.6309" width="7.17716" height="8.37549" rx="1.25" stroke="currentColor" strokeWidth="1.5" /><rect x="11.4105" y="18.4082" width="7.17716" height="11.5984" rx="1.25" stroke="currentColor" strokeWidth="1.5" /><rect x="21.9884" y="13.0781" width="7.17716" height="16.9287" rx="1.25" stroke="currentColor" strokeWidth="1.5" /></svg></i>
                          <span>Performance Evaluation</span>
                        </Link>
                        <ul className={`sub-menu ${openMenu4 ? "mm-show" : "mm-collapse"}`}>
                          <li className="submenu-header">
                            <span className="header-text">Performance Evaluation</span>
                          </li>
                          {userPermissions.includes("Userevaluation-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/evaluation`, "uil-star", "Evaluate Team")}
                          {userPermissions.includes("Userevaluation-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/teamevaluations`, "uil-chart-bar", "Team Evaluations")}
                          {userPermissions.includes("allusers-evaluation-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/all-users-evaluations`, "uil-chart-bar", "All Evaluations")}
                          {userPermissions.includes("myevaluation-list") && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/myevaluation`, "uil-chart-bar", "My Evaluation")}
                        </ul>
                      </li>
                    );
                  })()}

                  {/* HR Module */}
                  {DataParser.AllowedCompanyModules()?.includes("Human Resource") && (() => {
                    const perms = {
                      dashboard: "dashboard-list",
                      employees: "user-list",
                      attendance: "hrattendance-list",
                      leaves: "hrleaverequest-list",
                      wfh: "hrwfhrequest-list",
                      policy: "policy-list",
                    };

                    const canAccessHR = Object.values(perms).some((p) =>
                      userPermissions.includes(p)
                    );

                    if (!canAccessHR) return null;

                    const isHRActive = isParentActive(hrPaths);

                    return (
                      <li className={(isHRActive || openMenu2) ? "mm-active" : ""}>
                        <Link
                          to="#"
                          className={`has-arrow ${isHRActive ? "parent-active" : ""}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleToogleMenu2();
                          }}
                          {...tooltipProps("Human Resource")}
                        >
                          <i><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="1.5" /><path d="M4 21v-1a8 8 0 0 1 16 0v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg></i>
                          <span>Human Resource</span>
                        </Link>
                        <ul className={`sub-menu ${openMenu2 ? "mm-show" : "mm-collapse"}`}>
                          <li className="submenu-header">
                            <span className="header-text">Human Resource</span>
                          </li>
                          {userPermissions.includes(perms.dashboard) && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/dashboard`, "/assets/images/icons/Dashboard.svg", "Dashboard")}
                          {userPermissions.includes(perms.attendance) && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/attendance`, "/assets/images/icons/All Tasks.svg", "Attendance")}
                          {userPermissions.includes(perms.leaves) && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/leaves`, "/assets/images/icons/Leave Requests.svg", "Leave Requests")}
                          {userPermissions.includes(perms.wfh) && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/wfh_hr`, "/assets/images/icons/WFH Home.svg", "Work From Home")}
                          {userPermissions.includes(perms.policy) && renderSubMenuItem(`/${DataParser.CompanyIdentifierRole()}/policy`, "/assets/images/icons/Company HR Policy.svg", "Company HR Policy")}
                        </ul>
                      </li>
                    );
                  })()}

                  {(userPermissions.includes("acctivitylogs-list")) && (
                    <li className={isActive(`/${DataParser.CompanyIdentifierRole()}/activity-logs`) ? "active" : ""}>
                      <Link
                        to={`/${DataParser.CompanyIdentifierRole()}/activity-logs`}
                        className={isActive(`/${DataParser.CompanyIdentifierRole()}/activity-logs`) ? "active" : ""}
                        {...tooltipProps("Activity Logs")}
                      >
                        <i><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><path d="M3 3v5h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 7v5l4 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg></i>
                        <span>Activity Logs</span>
                      </Link>
                    </li>
                  )}

                  {/* Settings */}
                  {/* Settings */}
                  {(() => {
                    const settingsPermissions = [
                      "leadsource-list",
                      "communicationsource-list",
                      "role-list",
                      "departments-list",
                      "jobstatus-list",
                      "user-list",
                      "leaveperiod-list",
                      "leavetype-list",
                      "holiday-list",
                      "priority-list",
                      "performanceperiod-list",
                      "weightages-list",
                      "taskschedulingsettings-list",
                    ];

                    const canAccessSettings = settingsPermissions.some((perm) =>
                      userPermissions.includes(perm)
                    );

                    if (canAccessSettings) {
                      return (
                        <>


                          <li
                            className={
                              isActive(
                                `/${DataParser.CompanyIdentifierRole()}/settings`
                              )
                                ? "active"
                                : ""
                            }
                          >
                            <Link
                              to={`/${DataParser.CompanyIdentifierRole()}/settings`}
                              className={
                                isActive(
                                  `/${DataParser.CompanyIdentifierRole()}/settings`
                                )
                                  ? "active"
                                  : ""
                              }
                              {...tooltipProps("Settings")}
                            >
                              <i><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" strokeWidth="1.5" /></svg></i>
                              <span>Settings</span>
                            </Link>
                          </li>
                        </>
                      );
                    }

                    return null;
                  })()}
                </>
                  );
                })()
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Hidden Bootstrap modal trigger */}
      <div id="openDeleteChatRoomModal" data-bs-toggle="modal" data-bs-target="#deleteChatRoomModal" style={{ display: "none" }} />

      {/* Delete Chat Room Confirmation Modal */}
      <div id="deleteChatRoomModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
          <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
            <div className="modal-header border-0 pb-1">
              <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>
                {roomToDelete?.type === "direct" ? "Delete Conversation" : "Delete Channel"}
              </h5>
              <button type="button" className="btn-close" id="closeDeleteChatRoomModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setRoomToDelete(null)} />
            </div>
            <div className="modal-body pt-2 pb-2">
              <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>
                {roomToDelete?.type === "direct"
                  ? "Are you sure you want to delete this conversation?"
                  : `Are you sure you want to delete "${roomToDelete?.name}"?`}
              </p>
              <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                <i className="uil uil-exclamation-triangle me-1" />
                This action cannot be undone.
              </p>
            </div>
            <div className="modal-footer border-0 pt-1">
              <button type="button" className="btn btn-light waves-effect" data-bs-dismiss="modal" style={{ borderRadius: "5px", fontSize: "13px" }} onClick={() => setRoomToDelete(null)}>
                Cancel
              </button>
              <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDeleteRoom} style={{ borderRadius: "5px", fontSize: "13px" }}>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Global create modals triggered from sidebar + buttons. The hidden triggers are spans: a <button> is
          forced visible by the global button rule in custom-buttons.css (display:inline-flex !important) */}
      <span id="sidebarCreateTaskTrigger" style={{ display: 'none' }} data-bs-toggle="modal" data-bs-target="#sidebarCreateTaskModal" />
      <CreateTask id="sidebarCreateTaskModal" reFreshData={() => {}} priority={sidebarTaskPriority} taskOwner={sidebarTaskOwner} />

      <span id="sidebarCreateProjectTrigger" style={{ display: 'none' }} data-bs-toggle="modal" data-bs-target="#sidebarCreateProjectModal" />
      <CreateProject id="sidebarCreateProjectModal" reFreshData={() => {}} />

      {showSidebarCreateLead && (
        <div
          onClick={() => setShowSidebarCreateLead(false)}
          style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100005 }}
        >
          <CreateCrmLead
            onCancel={() => setShowSidebarCreateLead(false)}
            onSuccess={() => setShowSidebarCreateLead(false)}
          />
        </div>
      )}

      {roomMenuOpenId && (() => {
        const menuRoom = rooms.find(r => String(r._id) === String(roomMenuOpenId));
        if (!menuRoom) return null;
        return createPortal(
          <div
            className="room-menu-dropdown"
            style={{ position: "fixed", top: roomMenuPos.top, left: roomMenuPos.left, right: "auto", zIndex: 100010, pointerEvents: roomMenuReady ? "all" : "none" }}
            onClick={e => e.stopPropagation()}
          >
            <div className="room-menu-item" onClick={() => handleMuteRoom(menuRoom)}><span className="uil-bell-slash" style={{ fontSize: 13, color: '#6b7280' }} />{menuRoom.is_muted ? "Unmute" : "Mute"}</div>
            <div className="room-menu-item" onClick={() => handleMarkAsUnread(menuRoom)}><span className="uil-circle" style={{ fontSize: 13, color: '#6b7280' }} /> Mark as Unread</div>
            {canDeleteRoom(menuRoom) && (
              <div className="room-menu-item danger" onClick={() => handleDeleteRoom(menuRoom)}><span className="uil-trash" style={{ fontSize: 13, color: '#ef4444' }} /> Delete</div>
            )}
          </div>,
          document.body
        );
      })()}
    </>
  );
};

export default Sidebar;
